// English translations — default locale
const en = {
    // --- Navigation / Shell ---
    'nav.collection': 'My Collection',
    'nav.dashboard': 'Dashboard',
    'nav.inventory': 'Inventory',
    'nav.addItem': 'Add Item',
    'nav.batchAdd': 'Batch Add',
    'nav.library': 'Library',
    'nav.health': 'Health',
    'nav.stats': 'Stats',
    'nav.duplicates': 'Duplicates',
    'nav.activity': 'Activity',
    'nav.messages': 'Messages',
    'nav.community': 'Community',
    'nav.showroom': 'Showroom',
    'nav.reference': 'Reference',
    'nav.userGuide': 'User Guide',
    'nav.admin': 'Admin',
    'nav.about': 'About',
    'nav.adminPanel': 'Admin Panel',
    'nav.settings': 'Settings',
    'nav.logout': 'Logout',
    'nav.switchTheme': 'Switch theme',
    'footer.rights': 'All rights reserved.',
    'footer.builtBy': 'Built by Asaf Saar.',
    'footer.terms': 'Terms',
    'footer.privacy': 'Privacy',
    'footer.refund': 'Refund Policy',

    // --- Breadcrumbs ---
    'breadcrumb.dashboard': 'Dashboard',
    'breadcrumb.inventory': 'Inventory',
    'breadcrumb.showroom': 'Showroom',
    'breadcrumb.newItem': 'New Item',
    'breadcrumb.batchAdd': 'Batch Add',
    'breadcrumb.library': 'Library',
    'breadcrumb.health': 'Health',
    'breadcrumb.settings': 'Settings',
    'breadcrumb.userGuide': 'User Guide',
    'breadcrumb.admin': 'Admin',
    'breadcrumb.itemDetail': 'Item Detail',
    'breadcrumb.stats': 'Stats',
    'breadcrumb.activity': 'Activity Feed',
    'breadcrumb.messages': 'Messages',
    'breadcrumb.duplicates': 'Duplicates',

    // --- Landing page ---
    'landing.heroHeadline': 'Your',
    'landing.heroAccent': 'Collection',
    'landing.heroHeadlineSuffix': ', Organized and Preserved',
    'landing.heroSub': 'Retro computers, vintage cameras, watches, hi-fi gear — or any personal collection, from coins to stamps to toy cars. Every piece has a story. This is where you keep it.',
    'landing.goToDashboard': 'Go to Dashboard',
    'landing.getStarted': 'Start for Free',
    'landing.featuresTitle': 'Everything You Need',
    'landing.feature1Title': 'Catalog & Organize',
    'landing.feature1Desc': 'Build a detailed inventory across multiple vaults — each tailored for its collection type with specialized fields, categories, and platforms.',
    'landing.feature2Title': 'Track Condition',
    'landing.feature2Desc': 'Document the condition of each piece — from mint-in-box to well-loved — so you always know the state of your collection.',
    'landing.feature3Title': 'Export & Share',
    'landing.feature3Desc': 'Export your full inventory as CSV, JSON, or a designed PDF catalog for backups, insurance records, or sharing with fellow collectors.',
    'landing.vaultsTitle': 'One App, Multiple Vaults',
    'landing.vaultsSub': 'Each vault is purpose-built for its collection type — with the right categories, fields, and AI prompts baked in.',
    'landing.vaultRetroComputers': 'Retro Computers',
    'landing.vaultRetroComputersDesc': 'Vintage computers, consoles, peripherals, and software. Track CPUs, memory, video systems, and more.',
    'landing.vaultVintageCameras': 'Vintage Cameras',
    'landing.vaultVintageCamerasDesc': 'Film cameras, lenses, and analog photography gear. Track lens mounts, film formats, and shutter speeds.',
    'landing.vaultWatches': 'Watches',
    'landing.vaultWatchesDesc': 'Mechanical and quartz timepieces. Track movements, case materials, complications, and service history.',
    'landing.vaultRetroAudio': 'Retro Audio / Hi-Fi',
    'landing.vaultRetroAudioDesc': 'Turntables, amplifiers, speakers, and tape decks. Track watts, impedance, and tube types.',
    'landing.footer': 'All rights reserved.',
    'landing.switchTheme': 'Switch theme',

    // --- Login ---
    'login.subtitle': 'Retro Computing Inventory',
    'login.tabLogin': 'Login',
    'login.tabRegister': 'Register',
    'login.displayName': 'Display Name',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.placeholderName': 'RetroFan42',
    'login.placeholderEmail': 'user@example.com',
    'login.placeholderPassword': 'Min 8 characters',
    'login.loading': 'Loading...',
    'login.createAccount': 'Create Account',
    'login.somethingWentWrong': 'Something went wrong',

    // --- Dashboard ---
    'dashboard.title': 'Dashboard',
    'dashboard.totalItems': 'Total Items',
    'dashboard.working': 'Working',
    'dashboard.alerts': 'Alerts',
    'dashboard.urgentAlerts': 'Urgent Alerts',
    'dashboard.viewAll': 'View All',
    'dashboard.recentlyAdded': 'Recently Added',
    'dashboard.emptyTitle': 'Your vault is empty',
    'dashboard.emptyDesc': 'Add your first retro computing item to get started.',
    'dashboard.addFirstItem': 'Add First Item',

    // --- Inventory list ---
    'inventory.title': 'Inventory',
    'inventory.exportCsv': 'Export CSV',
    'inventory.exportJson': 'Export JSON',
    'inventory.exportPdf': 'Export PDF',
    'inventory.addItem': 'Add Item',
    'inventory.searchPlaceholder': 'Search items...',
    'inventory.allCategories': 'All Categories',
    'inventory.allPlatforms': 'All Platforms',
    'inventory.allConditions': 'All Conditions',
    'inventory.allVideoSystems': 'All Video Systems',
    'inventory.allSubcategories': 'All Subcategories',
    'inventory.allUsers': 'All Users',
    'inventory.myItems': 'My Items',
    'inventory.clearAll': 'Clear all',
    'inventory.clearFilters': 'Clear filters',
    'inventory.resetFilters': 'Reset filters',
    'inventory.noMatch': 'No items match your filters',
    'inventory.emptyVault': 'Your vault is empty',
    'inventory.noMatchDesc': 'Try clearing some filters to see more results.',
    'inventory.emptyDesc': 'Add your first retro computing item to get started.',
    'inventory.loadingInventory': 'Loading inventory...',
    'inventory.gridView': 'Grid view',
    'inventory.tableView': 'Table view',
    'inventory.sortBy': 'Sort by',
    'inventory.sort.createdAt': 'Date Added',
    'inventory.sort.updatedAt': 'Last Updated',
    'inventory.sort.name': 'Name',
    'inventory.sort.category': 'Category',
    'inventory.sort.platform': 'Platform',
    'inventory.sort.condition': 'Condition',
    'inventory.sort.subcategory': 'Subcategory',
    'inventory.sort.acquisitionDate': 'Acquisition Date',
    'inventory.sort.acquisitionPrice': 'Acquisition Price',
    'inventory.sort.launchDate': 'Launch Date',
    'inventory.sort.launchPrice': 'Launch Price',

    // --- Inventory detail ---
    'itemDetail.backToInventory': 'Back to Inventory',
    'itemDetail.backToShowroom': 'Back to Showroom',
    'itemDetail.editItem': 'Edit Item',
    'itemDetail.addNewItem': 'Add New Item',
    'itemDetail.removeFromShowroom': 'Remove from Showroom',
    'itemDetail.showroom': 'Showroom',
    'itemDetail.edit': 'Edit',
    'itemDetail.delete': 'Delete',
    'itemDetail.noImageUploaded': 'No image uploaded',
    'itemDetail.uploadNew': 'Upload New',
    'itemDetail.editImage': 'Edit Image',
    'itemDetail.platform': 'Platform',
    'itemDetail.category': 'Category',
    'itemDetail.subcategory': 'Subcategory',
    'itemDetail.condition': 'Condition',
    'itemDetail.quantity': 'Quantity',
    'itemDetail.acquired': 'Acquired',
    'itemDetail.price': 'Price',
    'itemDetail.owner': 'Owner',
    'itemDetail.location': 'Location',
    'itemDetail.added': 'Added',
    'itemDetail.cpu': 'CPU',
    'itemDetail.memory': 'Memory',
    'itemDetail.launchInfo': 'Launch Info',
    'itemDetail.launchPrice': 'Launch Price',
    'itemDetail.inflationAdjusted': 'Inflation-Adjusted',
    'itemDetail.customNotes': 'Notes',
    'itemDetail.files': 'Files',
    'itemDetail.deleteItemTitle': 'Delete Item',
    'itemDetail.deleteConfirm': 'Are you sure you want to delete',
    'itemDetail.deleteWarning': 'This action cannot be undone.',
    'itemDetail.deleting': 'Deleting...',
    'itemDetail.cancel': 'Cancel',
    'itemDetail.loadingItem': 'Loading item...',
    'itemDetail.itemNotFound': 'Item not found.',
    'itemDetail.createItem': 'Create Item',
    'itemDetail.name': 'Name',
    'itemDetail.description': 'Description',
    'itemDetail.reanalyze': 'Re-analyze',
    'itemDetail.reviewTitle': 'AI Analysis Review',
    'itemDetail.reviewField': 'Field',
    'itemDetail.reviewCurrent': 'Current',
    'itemDetail.reviewSuggested': 'Suggested',
    'itemDetail.reviewAcceptSelected': 'Apply Selected',
    'itemDetail.reviewDismiss': 'Dismiss',
    'itemDetail.reviewSelectAll': 'Select All',
    'itemDetail.reviewNoChanges': 'No differences found — AI suggestions match current values.',
    'itemDetail.reviewConfidence': 'Confidence',
    'itemDetail.reviewLaunchCurrency': 'Launch Currency',
    'itemDetail.reanalyzeFailed': 'Failed to analyze image. Please try again.',
    'itemDetail.reanalyzeApplied': 'AI suggestions applied successfully.',
    'itemDetail.imageSaved': 'Image saved',
    'itemDetail.imageUploadFailed': 'Failed to save image',

    // --- Image Gallery ---
    'imageGallery.setPrimary': 'Set as primary',
    'imageGallery.deleteImage': 'Image deleted',
    'imageGallery.primaryBadge': 'Primary',
    'imageGallery.addImage': 'Add Image',
    'imageGallery.noImages': 'No images uploaded',
    'imageGallery.confirmDelete': 'Are you sure you want to delete this image?',
    'imageGallery.maxReached': 'Maximum number of images reached',

    // --- Item Form ---
    'itemForm.name': 'Name',
    'itemForm.namePlaceholder': 'e.g., Commodore 64 Rev B',
    'itemForm.nameRequired': 'Name is required',
    'itemForm.category': 'Category',
    'itemForm.platform': 'Platform',
    'itemForm.subcategory': 'Subcategory',
    'itemForm.subcategoryPlaceholder': 'e.g., Amiga 500, Game, Graphics Card',
    'itemForm.condition': 'Condition',
    'condition.mint': 'Mint',
    'condition.excellent': 'Excellent',
    'condition.good': 'Good',
    'condition.fair': 'Fair',
    'condition.poor': 'Poor',
    'condition.parts': 'Parts',
    'category.Computer': 'Computer',
    'category.Console': 'Console',
    'category.Peripheral': 'Peripheral',
    'category.Software': 'Software',
    'category.Documentation': 'Documentation',
    'category.Media': 'Media',
    'category.Component': 'Component',
    'category.Accessory': 'Accessory',
    'category.Other': 'Other',
    'platform.3DO': '3DO',
    'platform.Amiga': 'Amiga',
    'platform.Amstrad': 'Amstrad',
    'platform.Apple': 'Apple',
    'platform.Atari': 'Atari',
    'platform.Atari 2600': 'Atari 2600',
    'platform.Atari Jaguar': 'Atari Jaguar',
    'platform.BBC Micro': 'BBC Micro',
    'platform.ColecoVision': 'ColecoVision',
    'platform.Commodore': 'Commodore',
    'platform.Game Boy': 'Game Boy',
    'platform.Game Boy Advance': 'Game Boy Advance',
    'platform.IBM PC': 'IBM PC',
    'platform.Intellivision': 'Intellivision',
    'platform.MSX': 'MSX',
    'platform.N64': 'N64',
    'platform.NES': 'NES',
    'platform.Neo Geo': 'Neo Geo',
    'platform.PS1': 'PlayStation',
    'platform.Sega Genesis': 'Sega Genesis',
    'platform.Sega Master System': 'Sega Master System',
    'platform.Sega Saturn': 'Sega Saturn',
    'platform.SNES': 'SNES',
    'platform.Spectrum': 'Spectrum',
    'platform.Tandy': 'Tandy',
    'platform.TI-99': 'TI-99',
    'platform.TurboGrafx-16': 'TurboGrafx-16',
    'platform.Other': 'Other',
    'itemForm.quantity': 'Quantity',
    'itemForm.description': 'Description',
    'itemForm.descriptionPlaceholder': 'Notes about this item...',
    'itemForm.location': 'Location',
    'itemForm.locationPlaceholder': 'e.g. Shelf A, Storage Room, Display Case',
    'itemForm.acquisitionDate': 'Acquisition Date',
    'itemForm.acquisitionPrice': 'Acquisition Price',
    'itemForm.invalidPrice': 'Invalid price format',
    'itemForm.currency': 'Currency',
    'itemForm.videoSystem': 'Video System',
    'itemForm.specsSection': 'Specs',
    'itemForm.cpu': 'CPU / Processor',
    'itemForm.cpuPlaceholder': 'e.g., MOS 6510 @ 1 MHz',
    'itemForm.memory': 'Memory',
    'itemForm.memoryPlaceholder': 'e.g., 64 KB RAM',
    'itemForm.launchInfoSection': 'Original Launch Info',
    'itemForm.launchDate': 'Launch Date',
    'itemForm.launchDatePlaceholder': 'e.g., 1982-08',
    'itemForm.launchPrice': 'Launch Price',
    'itemForm.launchPriceCurrency': 'Currency',
    'itemForm.inflationAdjustedPrice': 'Inflation-Adjusted (USD)',
    'itemForm.customNotes': 'Custom Notes',
    'itemForm.customNotesPlaceholder': 'Any additional notes about this item...',
    'itemForm.otherPlaceholder': 'Specify...',
    'itemForm.customFields': 'Custom Fields',
    'itemForm.customFieldName': 'Field Name',
    'itemForm.customFieldValue': 'Value',
    'itemForm.addCustomField': 'Add Field',
    'videoSystem.PAL': 'PAL',
    'videoSystem.NTSC': 'NTSC',
    'videoSystem.SECAM': 'SECAM',
    'videoSystem.Dual': 'Dual',
    'videoSystem.Other': 'Other',
    'itemForm.saving': 'Saving...',
    'itemForm.saveItem': 'Save Item',
    'itemForm.cancel': 'Cancel',
    'itemForm.updateItem': 'Update Item',

    // --- Item Card ---
    'itemCard.noImage': 'No Image',
    'itemCard.qty': 'Qty',

    // --- Item Table ---
    'itemTable.name': 'Name',
    'itemTable.platform': 'Platform',
    'itemTable.category': 'Category',
    'itemTable.subcategory': 'Subcategory',
    'itemTable.condition': 'Condition',
    'itemTable.qty': 'Qty',
    'itemTable.status': 'Status',
    'itemTable.added': 'Added',
    'itemTable.owner': 'Owner',
    'itemTable.empty': 'No items found. Start building your collection!',

    // --- Showroom ---
    'showroom.title': 'Showroom',
    'showroom.searchPlaceholder': 'Search showcased items...',
    'showroom.allCategories': 'All Categories',
    'showroom.allPlatforms': 'All Platforms',
    'showroom.allConditions': 'All Conditions',
    'showroom.clearAll': 'Clear all',
    'showroom.clearFilters': 'Clear filters',
    'showroom.favoritesOnly': 'Show favorites only',
    'showroom.showAll': 'Show all items',
    'showroom.includeMyItems': 'Include my items',
    'showroom.hideMyItems': 'Hide my items',
    'showroom.noMatch': 'No items match your filters',
    'showroom.emptyTitle': 'No items showcased yet',
    'showroom.noMatchDesc': 'Try clearing some filters to see more results.',
    'showroom.emptyDesc': 'When users showcase their collection items, they will appear here.',
    'showroom.loadingShowroom': 'Loading showroom...',

    // --- Library ---
    'library.title': 'The Library',
    'library.insertDisk': 'INSERT DISK',
    'library.cancel': 'Cancel',
    'library.insertDiskHeader': '=== INSERT DISK ===',
    'library.fileName': 'File Name',
    'library.fileType': 'File Type',
    'library.platform': 'Platform',
    'library.any': 'Any',
    'library.description': 'Description',
    'library.optionalDescription': 'Optional description',
    'library.chooseFile': 'Choose File',
    'library.noFileChosen': 'No file chosen',
    'library.loading': 'LOADING...',
    'library.loadCommand': 'LOAD "*",8,1',
    'library.searchPlaceholder': 'Search files...',
    'library.allTypes': 'All Types',
    'library.allPlatforms': 'All Platforms',
    'library.loadingLibrary': 'Loading library...',
    'library.readyNoFiles': 'READY.\nNO FILES FOUND.',
    'library.download': 'Download',
    'library.deleteFile': 'Delete',
    'library.prev': 'Prev',
    'library.next': 'Next',

    // --- Health ---
    'health.title': 'Maintenance Pulse',
    'health.loadingHealth': 'Loading health data...',
    'health.noData': 'No health data available.',
    'health.totalItems': 'Total Items',
    'health.working': 'Working',
    'health.recapProgress': 'Recap Progress',
    'health.activeRetrobright': 'Active Retrobright',
    'health.totalLinks': 'Total Links',
    'health.conditionBreakdown': 'Condition Breakdown',
    'health.urgentAlerts': 'Urgent Alerts',

    // --- Settings ---
    'settings.title': 'Settings',
    'settings.profile': 'Profile',
    'settings.appearance': 'Appearance',
    'settings.language': 'Language',
    'settings.inventory': 'Inventory',
    'settings.defaultView': 'Default View',
    'settings.itemsPerPage': 'Items Per Page',
    'settings.about': 'About',
    'settings.aboutLine1': 'SiliconVault - Retro Computing Inventory Manager',
    'settings.aboutLine2': 'Preserving the 8 & 16 bit era, one item at a time.',

    // --- About page ---
    'about.appDescription': 'A comprehensive inventory management system for collectors. Retro computers, vintage cameras, watches, hi-fi gear — catalog your collection, track condition and history, and manage documentation across dedicated vaults.',
    'about.featuresTitle': 'Features',
    'about.feat1': 'Multi-vault inventory with vault-specific categories, platforms, and fields',
    'about.feat2': 'Item linking to map connections between related pieces in your collection',
    'about.feat3': 'Capacitor recap tracking with schematic uploads and per-component status',
    'about.feat4': 'Service history and maintenance tracking with before/after documentation',
    'about.feat6': 'Document library with file validation, SHA-256 hashing, and item association',
    'about.feat7': 'Maintenance health dashboard with auto-generated alerts and severity levels',
    'about.feat8': 'Built-in image editor with crop, rotate, zoom, and flip tools',
    'about.feat9': 'Export to CSV, JSON, or PDF for offline backups and reporting',
    'about.feat10': 'Role-based access control with admin and user permission tiers',
    'about.feat11': 'Full internationalization with English and Hebrew (RTL) support',
    'about.developerTitle': 'Developer',
    'about.developerName': 'Asaf Saar',
    'about.developerLinkedIn': 'Connect with me on LinkedIn',
    'about.developerBio': 'A software industry executive specializing in Product Management, and a lifelong retro computing collector since the Commodore 64 era. In the little free time I have, I build passion projects like SiliconVault — built entirely for the community, by a fellow collector giving back.',
    'about.builtWith': 'Built with',
    'about.licenseTitle': 'License & Terms',
    'about.licenseBody': 'SiliconVault is proprietary software. The web platform offers a free tier with core features. Pro subscriptions and the Desktop app unlock additional capabilities — see siliconvault.app for details.',
    'about.communityBody': 'This platform is built for collectors, by a fellow collector. Collection management, showroom, trading, and all community features exist for hobbyists to connect and share their passion. Everything here is by the users, for the users.',
    'about.disclaimerTitle': 'Disclaimer',
    'about.disclaimerBody': 'SiliconVault is an information-only platform. All trades, transactions, and interactions are strictly peer-to-peer. The platform owner does not verify the condition of items, the identity of users, or the accuracy of market data, and assumes no liability for user-generated content, financial loss, or disputes. Hardware safety is the user\'s responsibility; the platform owner is not liable for property damage or personal injury resulting from the use or repair of vintage equipment. Service is provided "as-is" without warranty.',
    'about.disclaimerTos': 'By using SiliconVault you agree to our {terms} and {privacy}.',
    'about.privacyTitle': 'Your Privacy',
    'about.privacyBody': 'Your data is never sold, shared with third parties, or used for advertising. Collections are private by default — you choose what to share via the Showroom. We do not store or display precise geographic location data of collections.',
    'about.aiTitle': 'AI Disclosure',
    'about.aiBody': 'AI is used to assist in identifying items from photos and generating specifications. Your personal collection data remains yours and is not used to train AI models.',
    'about.dataTitle': 'Data Portability',
    'about.dataBody': 'You can export your entire collection to CSV, JSON, or a PDF catalog at any time from the Inventory page. Your data is always yours to take.',
    'about.techTitle': 'Infrastructure',
    'about.techBody': 'Hosted on Vercel with a Neon PostgreSQL database. Authentication via secure JWT tokens in httpOnly cookies with bcrypt password hashing. All connections encrypted via TLS.',
    'settings.accountDetails': 'Account Details',
    'settings.displayName': 'Display Name',
    'settings.email': 'Email',
    'settings.saving': 'Saving...',
    'settings.saveChanges': 'Save Changes',
    'settings.profileUpdated': 'Profile updated',
    'settings.failedToUpdateProfile': 'Failed to update profile',
    'settings.changePassword': 'Change Password',
    'settings.currentPassword': 'Current Password',
    'settings.newPassword': 'New Password',
    'settings.changing': 'Changing...',
    'settings.passwordChanged': 'Password changed',
    'settings.failedToChangePassword': 'Failed to change password',
    'settings.confirmNewPassword': 'Confirm New Password',
    'settings.passwordsDoNotMatch': 'Passwords do not match',
    'settings.themeGreenPhosphor': 'Green Phosphor (P1)',
    'settings.themeAmberPhosphor': 'Amber Phosphor (P3)',
    'settings.themeCommodore': 'Commodore 64',
    'settings.themeAtari': 'Atari 800XL',
    'settings.themeSpectrum': 'ZX Spectrum',
    'settings.themeAmstrad': 'Amstrad CPC 464',
    'settings.themeAmiga': 'Amiga Workbench',
    'settings.themeVuMeter': 'VU Meter',
    'settings.themeBrushedAluminum': 'Brushed Aluminum',
    'settings.themeDarkroom': 'Darkroom',
    'settings.themeChromeLeather': 'Chrome & Leather',
    'settings.themeMidnightDial': 'Midnight Dial',
    'settings.themeGuilloche': 'Guilloché',
    'settings.themeReelToReel': 'Reel-to-Reel',
    'settings.themeVinylGroove': 'Vinyl Groove',
    'settings.themeTubeGlow': 'Tube Glow',
    'settings.themeKodachrome': 'Kodachrome',
    'settings.themeFilmNoir': 'Film Noir',
    'settings.themeCyanotype': 'Cyanotype',
    'settings.themePatina': 'Patina',
    'settings.themeRoseGold': 'Rosé Gold',
    'settings.themeLume': 'Lume',
    'settings.themeModernDark': 'Modern Dark',
    'settings.themeModernLight': 'Modern Light',
    'settings.showTicker': 'Showroom Ticker',
    'settings.tickerOn': 'On',
    'settings.tickerOff': 'Off',

    // --- Admin ---
    'admin.title': 'Admin',
    'admin.accessDenied': 'Access Denied',
    'admin.accessDeniedMessage': 'Only admins can access the admin panel.',
    'admin.addUser': '+ Add User',
    'admin.name': 'Name',
    'admin.email': 'Email',
    'admin.role': 'Role',
    'admin.joined': 'Joined',
    'admin.you': 'you',
    'admin.resetPw': 'Reset PW',
    'admin.ban': 'Ban',
    'admin.addUserTitle': 'Add User',
    'admin.displayName': 'Display Name',
    'admin.password': 'Password',
    'admin.cancel': 'Cancel',
    'admin.adding': 'Adding...',
    'admin.userAddedSuccess': 'User added successfully',
    'admin.failedToAddUser': 'Failed to add user',
    'admin.roleUpdated': 'Role updated',
    'admin.failedToUpdateRole': 'Failed to update role',
    'admin.resetPasswordTitle': 'Reset Password',
    'admin.resetPasswordDesc': 'Set a new password for',
    'admin.resetPasswordSuffix': '. They will need to use this password on their next login.',
    'admin.newPassword': 'New Password',
    'admin.confirmPassword': 'Confirm Password',
    'admin.repeatNewPassword': 'Repeat new password',
    'admin.passwordMinLength': 'Password must be at least 8 characters',
    'admin.passwordsDoNotMatch': 'Passwords do not match',
    'admin.resetting': 'Resetting...',
    'admin.resetPassword': 'Reset Password',
    'admin.passwordResetFor': 'Password reset for',
    'admin.failedToResetPassword': 'Failed to reset password',
    'admin.banUserTitle': 'Ban User',
    'admin.banConfirm': 'You are about to permanently ban',
    'admin.banWarn1': 'Their account will be deleted',
    'admin.banWarn2': 'All their inventory items will be deleted',
    'admin.banWarn3': 'All uploaded images will be removed',
    'admin.banIrreversible': 'This action cannot be undone.',
    'admin.banning': 'Banning...',
    'admin.banAndDelete': 'Ban & Delete',
    'admin.bannedSuccess': 'has been banned and their data deleted',
    'admin.failedToBan': 'Failed to ban user',
    'admin.loadingUsers': 'Loading users...',
    'admin.user': 'User',
    'admin.adminRole': 'Admin',
    'admin.lastLogin': 'Last Login',
    'admin.never': 'Never',
    'admin.items': 'Items',
    'admin.totalValue': 'Value',
    'admin.loadingStats': 'Loading stats...',
    'admin.statTotalUsers': 'Total Users',
    'admin.statTotalItems': 'Total Items',
    'admin.statTotalValue': 'Total Value',
    'admin.statForTrade': 'For Trade',
    'admin.statForSale': 'For Sale',
    'admin.statActiveTrades': 'Active Trades',
    'admin.statNewThisMonth': 'New This Month',
    'admin.statLibraryFiles': 'Library Files',
    'admin.statLibrarySize': 'Library Size',
    'admin.statCriticalAlerts': 'Critical Alerts',
    'admin.statUnresolvedAlerts': 'Unresolved Alerts',
    'admin.statActiveRetrobright': 'Active Retrobright',
    'admin.sectionCommunity': 'Community',
    'admin.sectionSystem': 'System',

    // Admin Tabs
    'admin.tabOverview': 'Overview',
    'admin.tabUsers': 'Users',
    'admin.tabInventory': 'Inventory',
    'admin.tabOffers': 'Offers',

    // Admin User Search & Pagination
    'admin.searchUsersPlaceholder': 'Search by name or email...',
    'admin.allRoles': 'All Roles',
    'admin.prevPage': 'Previous',
    'admin.nextPage': 'Next',
    'admin.pageOf': 'Page {page} of {totalPages}',
    'admin.viewInventory': 'View Items',

    // Admin User Inventory Modal
    'admin.userInventoryTitle': "{name}'s Inventory",
    'admin.searchItemsPlaceholder': 'Search items...',
    'admin.noItemsFound': 'No items found.',
    'admin.loadingItems': 'Loading items...',

    // Admin Offers Panel
    'admin.allStatuses': 'All Statuses',
    'admin.pending': 'Pending',
    'admin.accepted': 'Accepted',
    'admin.declined': 'Declined',
    'admin.withdrawn': 'Withdrawn',
    'admin.searchOffersPlaceholder': 'Search by user name...',
    'admin.offerFrom': 'From',
    'admin.offerTo': 'To',
    'admin.offerStatus': 'Status',
    'admin.offerItems': 'Items',
    'admin.offerMoney': 'Money',
    'admin.offerCreated': 'Created',
    'admin.offerActions': 'Actions',
    'admin.forceWithdraw': 'Force Withdraw',
    'admin.forceWithdrawTitle': 'Force Withdraw Offer',
    'admin.forceWithdrawConfirm': 'Force-withdraw this pending offer? Both users will be notified.',
    'admin.forceWithdrawing': 'Withdrawing...',
    'admin.forceWithdrawSuccess': 'Offer force-withdrawn',
    'admin.forceWithdrawFailed': 'Failed to force-withdraw offer',
    'admin.noOffers': 'No offers found.',
    'admin.loadingOffers': 'Loading offers...',

    // --- Peripheral Links ---
    'links.title': 'Peripheral Links',
    'links.plugIn': '+ Plug In',
    'links.loading': 'Loading links...',
    'links.noPeripherals': 'NO PERIPHERALS CONNECTED',
    'links.linkPeripheralTitle': 'Link Peripheral',
    'links.searchItems': 'Search Items',
    'links.searchPlaceholder': 'Type to search...',
    'links.linkType': 'Link Type',
    'links.notes': 'Notes',
    'links.optionalNotes': 'Optional notes...',
    'links.cancel': 'Cancel',
    'links.linking': 'Linking...',
    'links.createLink': 'Create Link',
    'links.unplug': 'Unplug',

    // --- Capacitor / Recap ---
    'cap.title': 'Recap Status',
    'cap.addCap': '+ Add Cap',
    'cap.cancel': 'Cancel',
    'cap.noCapsMapped': 'NO CAPACITORS MAPPED',
    'cap.designator': 'Designator',
    'cap.value': 'Value',
    'cap.type': 'Type',
    'cap.status': 'Status',
    'cap.voltage': 'Voltage',
    'cap.add': 'Add',

    // --- Retrobright ---
    'retro.title': 'Retrobright',
    'retro.newProject': '+ New Project',
    'retro.cancel': 'Cancel',
    'retro.projectName': 'Project Name',
    'retro.targetHours': 'Target Hours',
    'retro.create': 'Create',
    'retro.loading': 'Loading projects...',
    'retro.noProjects': 'NO RETROBRIGHT PROJECTS',
    'retro.stopTimer': 'Stop Timer',
    'retro.startTimer': 'Start Timer',
    'retro.complete': 'Complete',

    // --- Alerts ---
    'alerts.title': 'Maintenance Alerts',
    'alerts.addAlert': '+ Add Alert',
    'alerts.cancel': 'Cancel',
    'alerts.type': 'Type',
    'alerts.severity': 'Severity',
    'alerts.alertTitle': 'Title',
    'alerts.alertTitlePlaceholder': 'Alert title',
    'alerts.description': 'Description',
    'alerts.optionalDetails': 'Optional details...',
    'alerts.alertDescription': 'Description',
    'alerts.optionalDescription': 'Optional description',
    'alerts.createAlert': 'Create Alert',
    'alerts.loading': 'Loading alerts...',
    'alerts.noActive': 'NO ACTIVE ALERTS',
    'alerts.noActiveAlerts': 'NO ACTIVE ALERTS',
    'alerts.resolve': 'Resolve',
    'alerts.reopen': 'Reopen',
    'alerts.capacitorCheck': 'Capacitor Check',
    'alerts.batteryCheck': 'Battery Check',
    'alerts.cleaning': 'Cleaning',
    'alerts.testing': 'Testing',
    'alerts.repair': 'Repair',
    'alerts.other': 'Other',

    // --- Image Editor ---
    'imageEditor.title': 'Edit Image',
    'imageEditor.zoom': 'Zoom',
    'imageEditor.rotate': 'Rotate',
    'imageEditor.rotateLeft': 'Rotate left 90\u00B0',
    'imageEditor.rotateRight': 'Rotate right 90\u00B0',
    'imageEditor.flipH': 'Flip horizontal',
    'imageEditor.flipV': 'Flip vertical',
    'imageEditor.reset': 'Reset all edits',
    'imageEditor.cancel': 'Cancel',
    'imageEditor.saving': 'Saving...',
    'imageEditor.applyAndUpload': 'Apply & Upload',
    'imageEditor.free': 'Free',
    'imageEditor.tabCrop': 'Crop',
    'imageEditor.tabAdjust': 'Adjust',
    'imageEditor.tabFilter': 'Filter',
    'imageEditor.aspectRatio': 'Aspect Ratio',
    'imageEditor.transform': 'Transform',
    'imageEditor.resetCrop': 'Reset crop',
    'imageEditor.brightness': 'Bright',
    'imageEditor.contrast': 'Contrast',
    'imageEditor.saturation': 'Saturate',
    'imageEditor.temperature': 'Temp',
    'imageEditor.resetAll': 'Reset All',
    'imageEditor.undo': 'Undo',
    'imageEditor.redo': 'Redo',
    'imageEditor.compare': 'Hold to compare',
    'imageEditor.filterOriginal': 'Original',
    'imageEditor.filterEnhanced': 'Enhanced',
    'imageEditor.filterVivid': 'Vivid',
    'imageEditor.filterBW': 'B&W',
    'imageEditor.filterVintage': 'Vintage',
    'imageEditor.filterCool': 'Cool',

    // --- Error Boundary ---
    'error.title': 'System Error',
    'error.message': "Something went wrong. This has been logged and we'll look into it.",
    'error.returnHome': 'Return to Home',

    // --- Common ---
    'common.cancel': 'Cancel',
    'common.result': 'result',
    'common.results': 'results',
    'common.user': 'user',
    'common.users': 'users',
    'common.session': 'session',
    'common.sessions': 'sessions',
    'common.recorded': 'recorded',
    'common.item': 'item',
    'common.items': 'items',

    // --- Health Dashboard (component) ---
    'healthDashboard.totalItems': 'Total Items',
    'healthDashboard.working': 'Working',
    'healthDashboard.recapProgress': 'Recap Progress',
    'healthDashboard.activeRetrobright': 'Active Retrobright',
    'healthDashboard.totalLinks': 'Total Links',
    'healthDashboard.conditionBreakdown': 'Condition Breakdown',
    'healthDashboard.urgentAlerts': 'Urgent Alerts',

    // --- User Guide ---
    'guide.title': 'User Guide',
    'guide.subtitle': 'SiliconVault is an inventory manager for collectors. Retro computers, vintage cameras, watches, hi-fi gear — organize, track, and preserve your collection across dedicated vaults.',

    // Guide group labels
    'guide.groupGettingStarted': 'Getting Started',
    'guide.groupCollection': 'Your Collection',
    'guide.groupItemFeatures': 'Item Features',
    'guide.groupOrganization': 'Organization & Insights',
    'guide.groupCommunity': 'Community',
    'guide.groupAccount': 'Account & Tips',

    // Getting Started
    'guide.gettingStarted': 'Getting Started',
    'guide.step1Title': 'Register an account',
    'guide.step1Desc': ' — sign up with email and password, or click "Continue with Google" to use your Google account. If you sign in with Google using an email that already has an account, the accounts are linked automatically.',
    'guide.step2Title': 'Add your first item',
    'guide.step2Desc': ' — click "Add Item" in the sidebar and fill in the details: name, category, platform, condition, currency, and more.',
    'guide.step3Title': 'Upload a photo',
    'guide.step3Desc': " — on any item's detail page, upload an image and use the built-in editor to crop, rotate, zoom, and flip.",
    'guide.step4Title': 'Browse and search',
    'guide.step4Desc': ' — use the Inventory page to filter by category, platform, or condition. Switch between grid and table views.',

    // Inventory Management
    'guide.inventoryManagement': 'Inventory Management',
    'guide.onThisPage': 'On This Page',
    'guide.tocWebVsDesktop': 'Web vs Desktop',
    'guide.addingItemsTitle': 'Adding Items',
    'guide.addingItemsDesc': 'Each item has a name, category, platform, condition, quantity, optional description, acquisition date, acquisition price, and currency. All users can create items. Items you create are visible only to you — admins can toggle "Show All Users" to see the full collection.',
    'guide.categoriesTitle': 'Categories',
    'guide.categoriesDesc': 'Each vault type has its own set of categories tailored to that collection. For example, the Retro Computers vault includes Computer, Peripheral, Software, and Documentation, while the Watches vault includes Dress Watch, Diver, Chronograph, and more.',
    'guide.platformsTitle': 'Platforms',
    'guide.platformsDesc': 'Platforms are specific to each vault type. Retro Computers includes Commodore, Atari, Amiga, Apple, and others. Vintage Cameras includes Nikon, Canon, Leica, Hasselblad. Watches includes Rolex, Omega, Seiko, and more.',
    'guide.conditionsTitle': 'Condition Grades',
    'guide.condMint': 'Mint',
    'guide.condMintDesc': ' — like new, original packaging',
    'guide.condExcellent': 'Excellent',
    'guide.condExcellentDesc': ' — minimal wear, fully functional',
    'guide.condGood': 'Good',
    'guide.condGoodDesc': ' — light wear, fully functional',
    'guide.condFair': 'Fair',
    'guide.condFairDesc': ' — noticeable wear, functional',
    'guide.condPoor': 'Poor',
    'guide.condPoorDesc': ' — heavy wear, may have issues',
    'guide.condParts': 'Parts',
    'guide.condPartsDesc': ' — for parts or repair only',
    'guide.currencyTitle': 'Currency',
    'guide.currencyDesc': 'Each item can have its own acquisition currency. Supported currencies: USD, EUR, GBP, ILS, SEK, JPY, AUD, CAD, CHF. Defaults to USD.',
    'guide.customFieldsTitle': 'Custom Fields',
    'guide.customFieldsDesc': 'Add up to 10 custom key-value pairs per item to track any detail that doesn\'t fit the built-in fields — serial numbers, mod notes, capacitor brands, whatever your collection needs.',

    // Peripheral Links
    'guide.peripheralLinks': 'Peripheral Links',
    'guide.peripheralLinksDesc': 'Link related items together to map your setup. For example, connect a floppy drive to a computer, a lens to a camera body, or a strap to a watch.',
    'guide.linkTypes': 'Link types',
    'guide.linkTypesDesc': ' — peripheral, expansion, storage, cable, power, other',
    'guide.linkBidirectional': 'Bidirectional',
    'guide.linkBidirectionalDesc': ' — links appear on both the host and peripheral item pages',
    'guide.linkDeleteWarnings': 'Delete warnings',
    'guide.linkDeleteWarningsDesc': ' — deleting an item with links shows a preflight warning listing all connected items',
    'guide.linkPlugIn': 'Plug In',
    'guide.linkPlugInDesc': " — use the \"Plug In\" button on any item's detail page to search and link another item",

    // Capacitor Map
    'guide.recapStatus': 'Recap Status (Capacitor Map)',
    'guide.recapStatusShort': 'Recap Status',
    'guide.recapDesc': "Track capacitor replacement progress for each item. Add capacitors by designator (e.g., C1, C47) with value, voltage, and type. Toggle each cap's status inline. Primarily useful for retro computers and vintage audio equipment.",
    'guide.recapStatuses': 'Statuses',
    'guide.recapStatusesDesc': ' — original (amber), replaced (green), leaking (red), removed, not applicable',
    'guide.recapProgress': 'Progress bar',
    'guide.recapProgressDesc': ' — shows percentage of applicable caps that have been replaced',
    'guide.recapSchematic': 'Schematic upload',
    'guide.recapSchematicDesc': ' — attach a board image or PDF reference via the API',

    // Retrobright
    'guide.retrobrightTracker': 'Retrobright Tracker',
    'guide.retrobrightDesc': 'Track UV de-yellowing projects with a built-in session timer. Create a project, set a target number of hours, then start and stop timed sessions. The tracker accumulates total hours across all sessions.',
    'guide.retroProjectStatuses': 'Project statuses',
    'guide.retroProjectStatusesDesc': ' — planned, in progress, curing, completed, cancelled',
    'guide.retroSessionTimer': 'Session timer',
    'guide.retroSessionTimerDesc': ' — start/stop with automatic duration calculation',
    'guide.retroPhotos': 'Before/after photos',
    'guide.retroPhotosDesc': ' — upload comparison images via the API',
    'guide.retroGlow': 'UV glow',
    'guide.retroGlowDesc': ' — active sessions display a purple glow indicator',

    // Community
    'guide.community': 'Community',
    'guide.communityDesc': 'SiliconVault includes a community layer where collectors can showcase items, maintain wanted lists, send trade or purchase offers, and discover each other\'s collections.',

    'guide.showroom': 'Showroom',
    'guide.showroomDesc': 'The Showroom displays items that users have chosen to share publicly. Browse showcased items from the entire community, filtered by category, platform, or condition.',
    'guide.showroomListings': 'Listing statuses',
    'guide.showroomListingsDesc': ' — Personal (private), For Trade, or For Sale — set per item from the item detail page',
    'guide.showroomPrice': 'Asking price',
    'guide.showroomPriceDesc': ' — items listed For Sale can include an asking price visible to other users',

    'guide.publicProfiles': 'Public Profiles',
    'guide.publicProfilesDesc': 'Each user can set up a public profile visible to the community. Customize it from Settings:',
    'guide.profileAvatar': 'Avatar',
    'guide.profileAvatarDesc': ' — upload a profile picture',
    'guide.profileBio': 'Bio',
    'guide.profileBioDesc': ' — short description about you or your collection',
    'guide.profileLocation': 'Location',
    'guide.profileLocationDesc': ' — your city or region, shown on your public profile',
    'guide.profileSlug': 'Profile URL',
    'guide.profileSlugDesc': ' — custom slug for a shareable profile link (e.g., /profile/retro-collector)',

    'guide.wantedList': 'Wanted List',
    'guide.wantedListDesc': 'Maintain a list of items you are looking for. Other collectors can see your public wanted items and reach out with offers.',
    'guide.wantedVisibility': 'Visibility',
    'guide.wantedVisibilityDesc': ' — each wanted item can be public (visible on your profile) or private',
    'guide.wantedCondition': 'Minimum condition',
    'guide.wantedConditionDesc': ' — optionally specify the lowest acceptable condition grade',

    'guide.offersTrading': 'Offers & Trading',
    'guide.offersTradingDesc': 'Send and receive trade or purchase offers with other collectors directly within SiliconVault.',
    'guide.offerCreate': 'Creating an offer',
    'guide.offerCreateDesc': ' — select items to offer, items to request, add an optional cash component and message',
    'guide.offerFlow': 'Offer flow',
    'guide.offerFlowDesc': ' — pending, accepted, declined, or withdrawn — both parties can track status',
    'guide.offerInbox': 'Inbox',
    'guide.offerInboxDesc': ' — filter by Received, Sent, or All — with status filters for pending offers',

    'guide.catalogSharing': 'Public Catalog Sharing',
    'guide.catalogSharingDesc': 'Share your collection with anyone — visitors can browse your catalog without registering. Set up a profile URL in Settings to enable sharing. If you have multiple vaults, you can control which ones are visible on your public profile.',
    'guide.sharingSlug': 'Profile URL',
    'guide.sharingSlugDesc': ' — set a custom slug (e.g. /profile/retro-fan) in Settings → Public Profile to make your catalog publicly accessible',
    'guide.sharingPublicAccess': 'Anonymous access',
    'guide.sharingPublicAccessDesc': ' — anyone with your link can view your showcased items, for-trade/for-sale listings, and profile without creating an account',
    'guide.sharingModal': 'Share modal',
    'guide.sharingModalDesc': ' — click "Share Catalog" on your profile or in Settings to open a sharing dialog with your URL, QR code, and social buttons',
    'guide.sharingSocial': 'Social sharing',
    'guide.sharingSocialDesc': ' — one-click sharing to X (Twitter), Facebook, WhatsApp, and Telegram; native share sheet on mobile devices',
    'guide.sharingAnalytics': 'Catalog analytics',
    'guide.sharingAnalyticsDesc': ' — view total catalog views, weekly/monthly breakdown, and top referrers in Settings → Public Profile',
    'guide.sharingMilestones': 'View milestones',
    'guide.sharingMilestonesDesc': ' — receive notifications when your catalog reaches 10, 50, 100, 500, and 1,000 views',
    'guide.sharingVaultVisibility': 'Per-vault visibility',
    'guide.sharingVaultVisibilityDesc': ' — in Settings → Public Profile → Shared Vaults, toggle which vaults appear on your public catalog. Unchecked vaults and their items are hidden from visitors',
    'guide.sharingVaultTabs': 'Vault tabs',
    'guide.sharingVaultTabsDesc': ' — when you share two or more vaults, visitors see a tab bar on your profile to filter by vault type (e.g. "All / Retro Computers / Watches")',
    'guide.sharingOg': 'Social previews',
    'guide.sharingOgDesc': ' — shared links show rich preview cards (title, description, avatar) on Twitter, Facebook, Slack, Discord, and other platforms',

    'guide.favorites': 'Favorites',
    'guide.favoritesDesc': 'Favorite any showcased item to bookmark it. Favorites count is visible on each item, and the item owner receives a notification when someone favorites their item.',

    'guide.notifications': 'Notifications',
    'guide.notificationsDesc': 'The bell icon in the header shows unread notifications. Notification types include:',
    'guide.notifOffer': 'Offer received',
    'guide.notifOfferDesc': ' — when someone sends you a trade or purchase offer',
    'guide.notifAccepted': 'Offer accepted/declined',
    'guide.notifAcceptedDesc': ' — when the other party responds to your offer',
    'guide.notifWanted': 'Wanted match',
    'guide.notifWantedDesc': ' — when a new showroom listing matches one of your wanted items',
    'guide.notifFavorite': 'Item favorited',
    'guide.notifFavoriteDesc': ' — when someone favorites one of your showcased items',
    'guide.notifProfile': 'Profile viewed',
    'guide.notifProfileDesc': ' — when another user visits your public profile',
    'guide.notifMilestone': 'Catalog milestone',
    'guide.notifMilestoneDesc': ' — when your public catalog reaches a view milestone (10, 50, 100, 500, 1,000)',

    // Library
    'guide.theLibrary': 'The Library',
    'guide.libraryDesc': 'A file repository for manuals, disk images, ROM dumps, schematics, and more. Upload files and optionally link them to specific inventory items.',
    'guide.fileTypes': 'File types',
    'guide.fileTypesDesc': ' — PDF manuals, .d64/.tap/.adf/.dsk disk images, ROMs, firmware, schematics',
    'guide.validation': 'Validation',
    'guide.validationDesc': ' — MIME type and extension checks per file type, 50MB max size',
    'guide.sha256': 'SHA-256 checksum',
    'guide.sha256Desc': ' — computed automatically on upload for integrity verification',
    'guide.filtering': 'Filtering',
    'guide.filteringDesc': ' — browse by file type, platform, or search by name',
    'guide.itemAssociation': 'Item association',
    'guide.itemAssociationDesc': " — linked files appear on the item's detail page",

    // Health Dashboard
    'guide.maintenancePulse': 'Maintenance Pulse (Health Dashboard)',
    'guide.maintenancePulseShort': 'Maintenance Pulse',
    'guide.maintenancePulseDesc': "A bird's-eye view of your collection's health. Aggregates data from inventory condition, capacitor maps, retrobright projects, peripheral links, and maintenance alerts into a single dashboard.",
    'guide.healthStats': 'Stats',
    'guide.healthStatsDesc': ' — total items, working percentage, recap progress, active retrobright projects, link count',
    'guide.healthCondition': 'Condition breakdown',
    'guide.healthConditionDesc': ' — items grouped by condition grade',
    'guide.healthUrgent': 'Urgent alerts',
    'guide.healthUrgentDesc': ' — prioritized list of unresolved maintenance alerts',
    'guide.healthAutoAlerts': 'Auto-generated alerts',
    'guide.healthAutoAlertsDesc': ' — vault-specific warnings created automatically (e.g., "Remove Clock Battery" for Amiga, "Service Overdue" for watches, "CLA Needed" for cameras)',
    'guide.healthSeverities': 'Alert severities',
    'guide.healthSeveritiesDesc': ' — critical, high, medium, low — with color-coded indicators',

    // Browsing & Filtering
    'guide.browsingFiltering': 'Browsing & Filtering',
    'guide.searchFiltersTitle': 'Search & Filters',
    'guide.searchFiltersDesc': 'Use the search bar to find items by name. Combine with category, platform, and condition filters to narrow results. Filters apply to exports too.',
    'guide.viewsSortingTitle': 'Views & Sorting',
    'guide.viewsSortingDesc': 'Toggle between grid view (cards with images) and table view (sortable columns). Click any column header in table view to sort ascending or descending.',
    'guide.paginationTitle': 'Pagination',
    'guide.paginationDesc': 'Results are paginated at 20 items per page. Use the Previous/Next buttons to navigate. The page resets to 1 when filters change.',

    // Image Editor
    'guide.imageEditor': 'Image Editor',
    'guide.imageEditorDesc': 'Upload JPEG, PNG, or WebP images — any size, automatically resized. The built-in editor lets you fine-tune images before saving:',
    'guide.editorCrop': 'Crop',
    'guide.editorCropDesc': ' — free or preset ratios (1:1, 4:3, 16:9)',
    'guide.editorZoom': 'Zoom',
    'guide.editorZoomDesc': ' — 1x to 3x with a precision slider',
    'guide.editorRotate': 'Rotate',
    'guide.editorRotateDesc': ' — 0-360\u00B0 with quick 90\u00B0 buttons',
    'guide.editorFlip': 'Flip',
    'guide.editorFlipDesc': ' — horizontal or vertical mirror',
    'guide.editorReset': 'Reset',
    'guide.editorResetDesc': ' — revert all edits to the original',

    // AI Image Analysis
    'guide.batchAdd': 'Batch Add',
    'guide.batchAddDesc': 'Add multiple items at once by dropping or selecting several images. Each image is analyzed by AI (if configured) and presented as an editable card with pre-filled form fields.',
    'guide.batchDrop': 'Drop or browse — ',
    'guide.batchDropDesc': 'drag and drop multiple images onto the drop zone, or click to select files. JPEG, PNG, and WebP are supported.',
    'guide.batchAi': 'Automatic analysis — ',
    'guide.batchAiDesc': 'images are analyzed in parallel (up to 3 at a time) using your configured AI provider. If AI is not configured, items are added with blank forms for manual entry.',
    'guide.batchReview': 'Review & edit — ',
    'guide.batchReviewDesc': 'each item appears as a collapsible card. Expand any card to edit the name, category, platform, condition, and all other fields before saving.',
    'guide.batchProgress': 'Progress tracking — ',
    'guide.batchProgressDesc': 'a progress banner shows how many items have been saved. You can navigate away while saving continues in the background.',
    'guide.batchRetry': 'Error handling — ',
    'guide.batchRetryDesc': 'if an item fails to analyze or save, it shows an error badge with a retry button. Successfully saved items can be cleared from the list.',

    'guide.aiImageAnalysis': 'AI Image Analysis',
    'guide.aiImageAnalysisDesc': 'SiliconVault can identify items from photos using AI — whether it\'s a vintage computer, a film camera, a mechanical watch, or an amplifier. Use the "Scan with AI" option when adding a new item to auto-fill the form fields (name, category, platform, condition, and more).',
    'guide.aiByokTitle': 'Bring Your Own Key',
    'guide.aiByokDesc': 'You can use AI analysis for free by providing your own API key. Go to Settings → AI Configuration to enter your credentials. Supported providers:',
    'guide.aiProviderOpenai': 'OpenAI',
    'guide.aiProviderOpenaiDesc': ' — use your OpenAI API key (GPT-4o)',
    'guide.aiProviderAzure': 'Azure OpenAI',
    'guide.aiProviderAzureDesc': ' — use your Azure OpenAI endpoint, deployment name, and API key',
    'guide.aiProviderGemini': 'Google Gemini',
    'guide.aiProviderGeminiDesc': ' — use your Gemini API key (defaults to Gemini 2.5 Flash)',
    'guide.aiProviderCustom': 'Custom',
    'guide.aiProviderCustomDesc': ' — any OpenAI-compatible endpoint (e.g. local models, third-party providers)',
    'guide.aiProTitle': 'Pro Plan',
    'guide.aiProDesc': 'Don\'t want to manage your own API key? Subscribe to SiliconVault Pro for hosted AI analysis powered by Google Gemini — 500 analyses per month, no configuration needed. Upgrade from Settings.',
    'guide.aiCostNote': 'With your own key, API usage is billed by your provider. Each scan typically costs a fraction of a cent. Pro subscribers get 500 analyses/month included.',

    // Export
    'guide.export': 'Data Backup & Export',
    'guide.exportDesc': 'SiliconVault offers multiple ways to protect and export your data, depending on whether you use the web or desktop app.',
    'guide.exportFormatsTitle': 'Export Formats (Web & Desktop)',
    'guide.exportCsv': 'CSV — ',
    'guide.exportCsvDesc': 'a spreadsheet-friendly format. Great for importing into Excel, Google Sheets, or other inventory tools.',
    'guide.exportJson': 'JSON — ',
    'guide.exportJsonDesc': 'a structured data format with timestamps. Ideal for programmatic access, archiving, or migrating between systems.',
    'guide.exportPdf': 'PDF Catalog — ',
    'guide.exportPdfDesc': 'a printable catalog with images. Choose from three tile layouts (Large, Compact, Dense). Perfect for insurance documentation, sharing, or printing.',
    'guide.exportFilters': 'Filtered Exports — ',
    'guide.exportFiltersDesc': 'exports respect your current search and filter selections, so you can export a subset of your collection. Exports are scoped to the active vault.',
    'guide.exportDesktopTitle': 'Database Backup & Restore (Desktop App)',
    'guide.exportDesktopDesc': 'The desktop app stores all your data in a local SQLite database. The Backup & Restore feature in Settings provides full database-level protection:',
    'guide.exportDesktopAuto': 'Automatic pre-update backups — ',
    'guide.exportDesktopAutoDesc': 'whenever the app detects pending database changes after an update, it creates a uniquely-named backup before applying them. These are never overwritten — each update produces its own snapshot.',
    'guide.exportDesktopManual': 'Manual backups — ',
    'guide.exportDesktopManualDesc': 'click "Create Backup" in Settings → Backup & Restore to snapshot your entire database at any time.',
    'guide.exportDesktopRestore': 'Restore — ',
    'guide.exportDesktopRestoreDesc': 'select any backup and click Restore. A safety snapshot of your current database is created automatically before the restore. The app must be restarted after restoring.',
    'guide.exportDesktopSchema': 'Schema warnings — ',
    'guide.exportDesktopSchemaDesc': 'if restoring a backup from an older app version, you will see a warning. Newer database changes will be re-applied automatically on the next startup.',
    'guide.exportDesktopFolder': 'Open Folder — ',
    'guide.exportDesktopFolderDesc': 'reveals the backup directory in your file manager for manual access.',
    'guide.exportWebTitle': 'Backing Up on the Web',
    'guide.exportWebDesc': 'The web app stores data in the cloud, so you don\'t need to worry about local backups. However, you can export your data at any time as CSV, JSON, or PDF for offline archival or to keep a local copy of your collection.',

    // Plans & Pricing
    'guide.plans': 'Plans & Pricing',
    'guide.plansDesc': 'SiliconVault offers a free tier and a Pro subscription. You can view your current plan and upgrade from the sidebar or the Upgrade page.',
    'guide.plansFreeTitle': 'Free',
    'guide.plansFree1': 'Up to 100 items in your collection',
    'guide.plansFree2': '1 vault type',
    'guide.plansFree3': '5 items in the community showroom',
    'guide.plansFree4': 'CSV and JSON export',
    'guide.plansFree5': '5 AI scans/month + unlimited with own API key',
    'guide.plansProTitle': 'Pro — $5/mo or $40/yr',
    'guide.plansPro1': 'Unlimited items',
    'guide.plansPro2': 'All vault types',
    'guide.plansPro3': 'Unlimited showroom items',
    'guide.plansPro4': '500 AI analyses per month (managed) + unlimited BYOK',
    'guide.plansPro5': 'CSV, JSON & PDF export',
    'guide.plansDesktopTitle': 'Desktop — $50 one-time',
    'guide.plansDesktop1': 'Fully offline — no internet or account required',
    'guide.plansDesktop2': 'Unlimited local items with SQLite storage',
    'guide.plansDesktop3': 'AI analysis with your own API key',
    'guide.plansDesktop4': 'Install on Windows, Mac & Linux',
    'guide.plansUpgrade': 'To upgrade to Pro, click the plan badge in the sidebar or visit the Upgrade page. You can switch between monthly and yearly billing at checkout.',
    'guide.plansUpgradePre': 'To learn more about the desktop app, visit the ',
    'guide.plansUpgradeLink': 'Download',
    'guide.plansUpgradePost': ' page.',

    // Roles & Permissions
    'guide.rolesPermissions': 'Roles & Permissions',
    'guide.adminRole': 'Admin',
    'guide.userRole': 'User',
    'guide.adminPerm1': 'See own items by default, toggle "Show All Users" to see everything',
    'guide.adminPerm2': 'Create, edit, and delete any item',
    'guide.adminPerm3': 'Upload and edit images on any item',
    'guide.adminPerm5': 'Access the Admin panel',
    'guide.adminPerm6': 'Add, remove, and change user roles',
    'guide.userPerm1': 'See only own items in inventory, dashboard, and exports',
    'guide.userPerm2': 'Create new items',
    'guide.userPerm3': 'Edit and delete own items only',
    'guide.userPerm4': 'Upload and edit images on own items',
    'guide.userPerm5': 'Upload files to the library',
    'guide.userPerm6': 'Track capacitor recaps, retrobright projects, and prices on own items',
    'guide.userPerm7': 'Export own inventory data',

    // Admin Panel
    'guide.adminPanel': 'Admin Panel',
    'guide.adminPanelDesc': 'Admins can access the Admin panel from the sidebar. From there you can:',
    'guide.adminAction1': 'View all registered users with their roles and join dates',
    'guide.adminAction2': 'Add new users with a specified role and temporary password',
    'guide.adminAction3': "Change any user's role between admin and user",
    'guide.adminAction4': 'Remove users (you cannot remove yourself)',

    // Navigation

    // Tips
    'guide.tips': 'Tips',
    'guide.tip1pre': 'Press ',
    'guide.tip1key': 'Esc',
    'guide.tip1post': ' to close any modal or dialog',
    'guide.tip2': 'Use the condition filter to quickly find items that need repair',
    'guide.tip3': 'Export a filtered list to share a specific subset of your collection',
    'guide.tip4': 'The dashboard shows your 8 most recently added items at a glance',
    'guide.tip5': 'Link peripherals to hosts to see your full setup mapped out',
    'guide.tip6': 'Check the Health dashboard regularly for auto-generated maintenance warnings',
    'guide.tip7': 'Use recap tracking to stay on top of capacitor replacement across your collection',
    'guide.tip8': 'List items as "For Trade" or "For Sale" to make them visible in the Showroom and attract offers',
    'guide.tip9': 'Add items to your Wanted list so other collectors can match you with what they have',
    'guide.tip10': 'Signed up with Google? Your account is linked automatically — no separate password needed',
    'guide.tip11': 'Use the Stats page to visualize your collection by platform, condition, and value',
    'guide.tip12': 'Check the Activity feed to see what other collectors are listing, trading, and showcasing',
    'guide.tip13': 'Send direct messages to other collectors from their profile or item detail pages',
    'guide.tip14': 'Run Duplicate Detection to find and merge similar items in your collection',
    'guide.tip15': 'Create Collection Sets from templates to track progress toward a complete set',
    'guide.tip16': 'Use Backup & Restore in Settings to create snapshots of your data before major changes',

    // --- Guide: Multi-Vault ---
    'guide.multiVault': 'Multi-Vault',
    'guide.multiVaultDesc': 'Organize your collection into separate vaults, each tailored to a specific collecting category. Switch between vaults using the vault selector in the top navigation bar.',
    'guide.vaultTypes': 'Vault Types — ',
    'guide.vaultTypesDesc': 'choose from Retro Computers, Retro Audio / Hi-Fi, Vintage Cameras, and Watches. Each type provides specialized categories, brands, and platform lists.',
    'guide.vaultSwitcher': 'Vault Switcher — ',
    'guide.vaultSwitcherDesc': 'use the dropdown in the header to switch between vaults. Your inventory, sets, stats, and wanted items are scoped to the active vault.',
    'guide.vaultCreate': 'Creating Vaults — ',
    'guide.vaultCreateDesc': 'create new vaults from the Vaults page. Each vault has a name and a type that determines its specialized fields.',
    'guide.vaultScoping': 'Data Scoping — ',
    'guide.vaultScopingDesc': 'items, collection sets, wanted lists, library files, and stats are all filtered by the active vault. Export also respects the vault scope.',


    // --- Stats Dashboard ---
    'guide.statsDashboard': 'Stats Dashboard',
    'guide.statsDashboardDesc': 'The Stats page provides visual analytics for your collection with interactive charts.',
    'guide.statsSummary': 'Summary Cards — ',
    'guide.statsSummaryDesc': 'total items, total value, unique platforms, and unique categories at a glance.',
    'guide.statsPlatformChart': 'Platform Distribution — ',
    'guide.statsPlatformChartDesc': 'donut chart showing how many items you own per platform.',
    'guide.statsConditionChart': 'Condition Breakdown — ',
    'guide.statsConditionChartDesc': 'bar chart of item conditions from Mint to Parts.',
    'guide.statsTimelineChart': 'Acquisition Timeline — ',
    'guide.statsTimelineChartDesc': 'area chart showing items added over the last 12 months.',
    'guide.statsValueChart': 'Value by Category — ',
    'guide.statsValueChartDesc': 'horizontal bar chart of total acquisition value grouped by category.',

    // --- Activity Feed ---
    'guide.activityFeed': 'Activity Feed',
    'guide.activityFeedDesc': 'A community-wide feed showing recent events from all collectors.',
    'guide.activityListed': 'Item Listed — ',
    'guide.activityListedDesc': 'when a collector lists an item for trade or sale.',
    'guide.activityTraded': 'Trade Completed — ',
    'guide.activityTradedDesc': 'when an offer is accepted between two collectors.',
    'guide.activityJoined': 'Member Joined — ',
    'guide.activityJoinedDesc': 'when a new collector registers on SiliconVault.',
    'guide.activityShowcased': 'Item Showcased — ',
    'guide.activityShowcasedDesc': 'when a collector adds an item to the showroom.',
    'guide.activityFilters': 'Type Filters — ',
    'guide.activityFiltersDesc': 'filter the feed by event type to see only what interests you.',

    // --- Direct Messaging ---
    'guide.directMessaging': 'Direct Messaging',
    'guide.directMessagingDesc': 'Send private messages to other collectors to discuss trades, ask questions, or coordinate.',
    'guide.msgStartConversation': 'Start a Conversation — ',
    'guide.msgStartConversationDesc': 'click "Send Message" on any collector\'s profile or item detail page.',
    'guide.msgThreads': 'Conversation Threads — ',
    'guide.msgThreadsDesc': 'the Messages page shows all your conversations with a split-panel layout.',
    'guide.msgUnread': 'Unread Indicators — ',
    'guide.msgUnreadDesc': 'unread message count appears in the sidebar nav and on each conversation.',
    'guide.msgNotifications': 'Notifications — ',
    'guide.msgNotificationsDesc': 'you receive a notification when someone sends you a new message.',
    'guide.msgProfileLink': 'Profile Links — ',
    'guide.msgProfileLinkDesc': 'click the avatar or name in a thread header to visit that collector\'s profile.',

    // --- Duplicate Detection ---
    'guide.duplicateDetection': 'Duplicate Detection',
    'guide.duplicateDetectionDesc': 'Scan your collection for potential duplicate items using fuzzy name matching.',
    'guide.dupScan': 'Scan — ',
    'guide.dupScanDesc': 'click "Scan for Duplicates" to find items with similar names.',
    'guide.dupReview': 'Side-by-Side Review — ',
    'guide.dupReviewDesc': 'compare potential duplicates with similarity scores and decide what to do.',
    'guide.dupDismiss': 'Dismiss — ',
    'guide.dupDismissDesc': 'mark a pair as "Not Duplicate" so it won\'t appear again.',
    'guide.dupMerge': 'Merge — ',
    'guide.dupMergeDesc': 'keep one item and transfer all linked data (links, capacitors, retrobright, alerts, files) from the other.',

    // --- Set Completeness ---
    'guide.setCompleteness': 'Collection Sets',
    'guide.setCompletenessDesc': 'Define target collections and track which items you own toward completing a set.',
    'guide.setTemplates': 'Templates — ',
    'guide.setTemplatesDesc': 'create a set from pre-defined templates tailored to each vault type.',
    'guide.setCustom': 'Custom Sets — ',
    'guide.setCustomDesc': 'build your own set from scratch with any items you choose.',
    'guide.setProgress': 'Progress Tracking — ',
    'guide.setProgressDesc': 'each set shows a progress bar with "X of Y" items owned.',
    'guide.setAutoMatch': 'Auto-Match — ',
    'guide.setAutoMatchDesc': 'automatically link set items to matching inventory entries by name.',
    'guide.setManualToggle': 'Manual Toggle — ',
    'guide.setManualToggleDesc': 'mark individual items as owned or not-owned with a single click.',

    // --- Guide navigation new entries ---

    // --- Community / Trading ---
    'nav.wanted': 'Wanted',
    'nav.offers': 'Offers',
    'nav.myProfile': 'My Profile',
    'nav.shareCatalog': 'Share Catalog',
    'breadcrumb.wanted': 'Wanted',
    'breadcrumb.offers': 'Offers',
    'breadcrumb.profile': 'Profile',
    'breadcrumb.offerDetail': 'Offer Detail',

    'community.items': 'Items',
    'community.showcased': 'Showcased',
    'community.forTrade': 'For Trade',
    'community.forSale': 'For Sale',
    'community.filterAll': 'All',
    'community.filterShowcase': 'Showcase',
    'community.filterForTrade': 'For Trade',
    'community.filterForSale': 'For Sale',
    'community.noPublicItems': 'No public items yet.',
    'community.loadingProfile': 'Loading profile...',
    'community.profileNotFound': 'Profile not found.',
    'community.wantedList': 'Wanted List',
    'community.publicProfile': 'Public Profile',
    'community.uploadAvatar': 'Upload Avatar',
    'community.removeAvatar': 'Remove',
    'community.bio': 'Bio',
    'community.bioPlaceholder': 'Tell us about your collection...',
    'community.location': 'Location',
    'community.locationPlaceholder': 'e.g., Tel Aviv, Israel',
    'community.profileSlug': 'Profile URL',
    'community.slugPlaceholder': 'e.g., retro-collector',
    'community.profileUpdated': 'Profile updated',
    'community.profileUpdateFailed': 'Failed to update profile',
    'community.avatarUpdated': 'Avatar updated',
    'community.avatarUpdateFailed': 'Failed to update avatar',
    'community.avatarRemoved': 'Avatar removed',
    'community.avatarRemoveFailed': 'Failed to remove avatar',
    'community.listingStatus': 'Listing Status',
    'community.statusPersonal': 'Personal',
    'community.statusForTrade': 'For Trade',
    'community.statusForSale': 'For Sale',
    'community.askingPrice': 'Asking price',
    'community.listingUpdated': 'Listing updated',
    'community.listingUpdateFailed': 'Failed to update listing',
    'community.addWantedItem': 'Add Wanted',
    'community.editWantedItem': 'Edit Wanted Item',
    'community.save': 'Save',
    'community.add': 'Add',
    'community.edit': 'Edit',
    'community.delete': 'Delete',
    'community.minCondition': 'Min Condition',
    'community.anyCondition': 'Any',
    'community.publiclyVisible': 'Publicly visible',
    'community.publiclyVisibleDesc': 'Others can see this item on your profile',
    'community.private': 'Private',
    'community.loadingWanted': 'Loading wanted items...',
    'community.noWantedItems': 'No wanted items yet',
    'community.noWantedItemsDesc': 'Add items you are looking for so other collectors can find them.',
    'community.wantedItemCreated': 'Wanted item added',
    'community.wantedItemCreateFailed': 'Failed to add wanted item',
    'community.wantedItemUpdated': 'Wanted item updated',
    'community.wantedItemUpdateFailed': 'Failed to update wanted item',
    'community.wantedItemDeleted': 'Wanted item removed',
    'community.wantedItemDeleteFailed': 'Failed to remove wanted item',
    'community.offers': 'Offers',
    'community.allOffers': 'All',
    'community.received': 'Received',
    'community.sent': 'Sent',
    'community.allStatuses': 'All Statuses',
    'community.pendingOnly': 'Pending',
    'community.loadingOffers': 'Loading offers...',
    'community.noOffers': 'No offers yet',
    'community.noOffersDesc': 'When you send or receive trade/buy offers, they will appear here.',
    'community.you': 'You',
    'community.offering': 'Offering',
    'community.requesting': 'Requesting',
    'community.from': 'From',
    'community.to': 'To',
    'community.message': 'Message',
    'community.messagePlaceholder': 'Add a message to your offer...',
    'community.offeredItems': 'Offered Items',
    'community.requestedItems': 'Requested Items',
    'community.noItemsOffered': 'No items offered (cash only)',
    'community.noItemsRequested': 'No items requested',
    'community.searchItems': 'Search items...',
    'community.tradeOffer': 'Trade Offer',
    'community.cashComponent': 'Cash Component',
    'community.accept': 'Accept',
    'community.decline': 'Decline',
    'community.withdraw': 'Withdraw',
    'community.created': 'Created',
    'community.responded': 'Responded',
    'community.offerAccepted': 'Offer accepted',
    'community.offerDeclined': 'Offer declined',
    'community.offerWithdrawn': 'Offer withdrawn',
    'community.offerActionFailed': 'Failed to update offer',
    'community.backToOffers': 'Back to Offers',
    'community.loadingOffer': 'Loading offer...',
    'community.offerNotFound': 'Offer not found.',
    'community.makeOffer': 'Make Offer',
    'community.sendOffer': 'Send Offer',
    'community.sending': 'Sending...',
    'community.offerSent': 'Offer sent',
    'community.offerSendFailed': 'Failed to send offer',
    'community.noListedItems': 'No listed items available.',
    'community.noOwnItems': 'You have no items to offer.',
    'community.dismissOffer': 'Dismiss',
    'community.offerDismissed': 'Offer dismissed',
    'community.offerDismissFailed': 'Failed to dismiss offer',

    // --- Notifications ---
    'notifications.title': 'Notifications',
    'notifications.markAllRead': 'Mark all read',
    'notifications.empty': 'No notifications',
    'notifications.emptyDesc': 'You\'re all caught up!',
    'notifications.offerReceived': 'New offer received',
    'notifications.offerAccepted': 'Offer accepted',
    'notifications.offerDeclined': 'Offer declined',
    'notifications.offerWithdrawn': 'Offer withdrawn',
    'notifications.wantedMatch': 'Wanted item match',
    'notifications.profileViewed': 'Profile viewed',
    'notifications.itemFavorited': 'Item favorited',

    // --- Favorites ---
    'favorites.add': 'Favorite',
    'favorites.remove': 'Unfavorite',
    'favorites.count': 'favorites',

    // --- AI Scan ---
    'aiScan.title': 'Scan with AI',
    'aiScan.optional': 'Optional — snap a photo to auto-fill, or skip and fill in the form manually below.',
    'aiScan.dropText': 'Drop a photo here, or click to browse',
    'aiScan.dropHint': 'JPEG, PNG, or WebP — any size. Use your camera on mobile.',
    'aiScan.analyze': 'Analyze',
    'aiScan.analyzing': 'Analyzing image...',
    'aiScan.clear': 'Clear',
    'aiScan.prefilled': 'Form fields pre-filled from AI analysis. Review before saving.',
    'aiScan.clickToEnlarge': 'Click to enlarge',
    'aiScan.imagePreview': 'Image Preview',
    'aiScan.failed': 'AI analysis failed. Please try again or fill in the form manually.',
    'aiScan.lowConfidence': 'Low confidence — the image may not be retro computing hardware. Please review carefully.',
    'aiScan.notConfiguredTitle': 'AI image analysis is not configured',
    'aiScan.notConfiguredDesc': 'Enter your API credentials to enable hardware identification.',
    'aiScan.notConfiguredLink': 'Open Settings',
    'aiScan.uploadTitle': 'Add Photo',
    'aiScan.uploadSubtitle': 'Optional — attach a photo to this item, or skip and add one later.',
    'aiScan.uploadDropText': 'Drop a photo here, or click to browse',
    'aiScan.invalidType': 'Only JPEG, PNG, and WebP images are allowed.',
    'aiScan.tooLarge': 'File is too large to process.',

    // --- Batch Upload ---
    'batch.title': 'Batch Add Items',
    'batch.subtitle': 'Drop multiple images to analyze and add them all at once. Review each item before saving.',
    'batch.dropText': 'Drop images here, or click to browse',
    'batch.dropMore': 'Drop more images to add to the batch',
    'batch.dropHint': 'JPEG, PNG, or WebP — select multiple files at once',
    'batch.queued': 'Queued',
    'batch.analyzing': 'Analyzing…',
    'batch.ready': 'Ready',
    'batch.error': 'Error',
    'batch.saving': 'Saving…',
    'batch.saved': 'Saved',
    'batch.lowConfidence': 'Low confidence',
    'batch.retry': 'Retry',
    'batch.remove': 'Remove',
    'batch.createAll': 'Create All ({count})',
    'batch.total': '{count} items',
    'batch.analyzingCount': '{count} analyzing',
    'batch.readyCount': '{count} ready',
    'batch.savedCountLabel': '{count} saved',
    'batch.savedCount': '{count} items created successfully',
    'batch.nameRequired': 'All items must have a name before saving.',
    'batch.saveFailed': 'Failed to save item. You can retry.',
    'batch.clearSaved': 'Clear Saved',
    'batch.savingProgress': 'Saving items... {done} of {total} complete',
    'batch.savingHint': 'You can navigate away — items will continue saving in the background.',
    'batch.allDone': 'All {count} items have been saved to your inventory.',
    'batch.doneWithErrors': '{saved} items saved, {errors} failed. You can retry the failed ones.',
    'batch.viewInventory': 'View Inventory',

    // --- Support / Donation ---
    'support.sectionTitle': 'Support',
    'support.cardTitle': 'Buy Me a Capacitor',
    'support.cardBody': 'SiliconVault is free — no fees, no ads, no subscriptions. Your data is never monetized and there are no analytics trackers or third-party data sharing. If it helps you organize your collection, consider chipping in to keep things running. This project is funded entirely by voluntary donations.',
    'support.infraTitle': 'Infrastructure',
    'support.infraVercel': 'Vercel — Hosting & CDN',
    'support.infraNeon': 'Neon — PostgreSQL Database',
    'support.infraAzure': 'OpenAI — AI Identification',
    'support.infraBrowserbase': 'Browserbase — Application Testing',
    'support.cardCosts': 'Funds go directly to these service costs. Nothing else.',
    'support.ctaButton': 'Support this project',
    'support.footerLink': 'Support this project',

    // --- Terms of Service ---
    'terms.title': 'Terms of Service',
    'terms.lastUpdated': 'Last updated: March 2026',
    'terms.acceptanceTitle': 'Acceptance of Terms',
    'terms.acceptanceBody': 'By accessing or using SiliconVault, you agree to be bound by these Terms of Service and our Refund Policy. If you do not agree to these terms, please do not use the platform. These terms apply to all tiers of the service, including the free web tier, Pro subscriptions, and the Desktop application.',
    'terms.accountTitle': 'Account Responsibility',
    'terms.accountBody': 'You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to provide accurate information during registration and to keep your account information up to date.',
    'terms.useTitle': 'Acceptable Use',
    'terms.useBody': 'You agree to use SiliconVault only for lawful purposes related to managing and sharing retro computing collections. You may not use the platform to post fraudulent listings, harass other users, distribute malware, or engage in any activity that violates applicable laws.',
    'terms.contentTitle': 'User Content',
    'terms.contentBody': 'You retain ownership of all content you upload to SiliconVault, including photos, descriptions, and documents. By uploading content, you grant SiliconVault a limited license to display it within the platform as needed to provide the service (e.g., Showroom listings). You are solely responsible for ensuring you have the right to share any content you upload.',
    'terms.paidServicesTitle': 'Paid Services & Billing',
    'terms.paidServicesBody': 'SiliconVault offers paid services including Pro subscriptions (recurring) and a one-time Desktop application purchase. Pro subscriptions renew automatically at the end of each billing cycle unless cancelled before the renewal date. You may cancel your Pro subscription at any time from your account settings; cancellation takes effect at the end of the current billing period and you will retain access until then. Desktop licenses are perpetual and granted per-user upon purchase. All prices are in USD and are subject to change with 30 days\' notice to active subscribers. Payment is processed by Lemon Squeezy, our merchant of record. By purchasing, you agree to Lemon Squeezy\'s terms of service. Refunds are governed by our Refund Policy.',
    'terms.ipTitle': 'Intellectual Property',
    'terms.ipBody': 'SiliconVault, including its design, code, and branding, is proprietary software owned by Asaf Saar. You may not copy, modify, distribute, or reverse-engineer any part of the platform without explicit written permission.',
    'terms.liabilityTitle': 'Limitation of Liability',
    'terms.liabilityBody': 'SiliconVault is provided "as-is" without warranties of any kind, whether express or implied, including but not limited to merchantability, fitness for a particular purpose, or non-infringement. The platform owner is not liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of the service, including but not limited to data loss, financial loss from peer-to-peer transactions, loss of profits, or property damage from following repair information found on the platform. For paid services, total liability shall not exceed the amount you paid in the twelve (12) months preceding the claim.',
    'terms.terminationTitle': 'Termination',
    'terms.terminationBody': 'We reserve the right to suspend or terminate accounts that violate these terms. You may delete your account at any time. Upon termination, your data will be deleted from our systems, though you may export it beforehand. If you hold an active Pro subscription, termination by us for cause (e.g., terms violation) does not entitle you to a refund for the remaining billing period. If you cancel your own account, your Pro subscription will not renew and access continues until the end of the paid period. Desktop licenses remain valid after account deletion but cannot be transferred.',
    'terms.modificationsTitle': 'Modifications',
    'terms.modificationsBody': 'We may update these terms from time to time. Continued use of SiliconVault after changes constitutes acceptance of the updated terms. Material changes will be communicated via the platform.',
    'terms.governingTitle': 'Governing Law',
    'terms.governingBody': 'These terms are governed by the laws of the State of Israel. Any disputes shall be resolved in the competent courts of Tel Aviv-Jaffa.',

    // --- Privacy Policy ---
    'privacy.title': 'Privacy Policy',
    'privacy.lastUpdated': 'Last updated: March 2026',
    'privacy.introTitle': 'Introduction',
    'privacy.introBody': 'SiliconVault is committed to protecting your privacy. This policy explains what data we collect, how we use it, and your rights regarding your personal information.',
    'privacy.collectTitle': 'What We Collect',
    'privacy.collectBody': 'We collect the minimum data necessary to provide the service: your email address and display name (for account creation), your collection data (items, photos, documents you upload), and basic usage logs (for security and debugging). If you purchase a Pro subscription or Desktop license, our payment processor (Lemon Squeezy) collects billing information on our behalf — we do not store your full credit card number or payment details on our servers. We do not collect precise geographic location data.',
    'privacy.useDataTitle': 'How We Use Your Data',
    'privacy.useDataBody': 'Your data is used solely to provide and improve the SiliconVault service. Collection data is stored to power your inventory, health tracking, and Showroom features. Usage logs help us identify and fix bugs.',
    'privacy.notDoTitle': 'What We Do NOT Do',
    'privacy.notDoBody': 'We do not sell your data to third parties. We do not use your data for advertising or marketing purposes. We do not share your personal information with third parties except as required by law. We do not use your collection data to train AI models.',
    'privacy.cookiesTitle': 'Cookies',
    'privacy.cookiesBody': 'SiliconVault uses a single httpOnly authentication cookie (vault_token) to maintain your login session. We do not use tracking cookies, analytics cookies, or any third-party cookie services.',
    'privacy.retentionTitle': 'Data Retention',
    'privacy.retentionBody': 'Your data is retained as long as your account is active. If you delete your account, all associated data is permanently removed from our systems. Backups may retain data for up to 30 days after deletion.',
    'privacy.exportTitle': 'Data Export & Portability',
    'privacy.exportBody': 'You can export your entire collection to CSV, JSON, or a PDF catalog at any time from the Inventory page. Your data is always yours to take with you.',
    'privacy.thirdPartyTitle': 'Third-Party Services',
    'privacy.thirdPartyBody': 'SiliconVault uses the following third-party services: Vercel (hosting and deployment), Neon (PostgreSQL database hosting), Azure OpenAI (AI-assisted item identification), and Lemon Squeezy (payment processing and merchant of record for Pro subscriptions and Desktop purchases). These services process data only as needed to provide their respective functions and are bound by their own privacy policies.',
    'privacy.paymentTitle': 'Payment Data',
    'privacy.paymentBody': 'All payment transactions are handled by Lemon Squeezy as our merchant of record. We receive only the information necessary to fulfill your order: your email address, transaction ID, subscription status, and license key. We do not receive, process, or store your credit card number, bank account details, or other sensitive payment credentials. For questions about how your payment data is handled, please refer to Lemon Squeezy\'s privacy policy.',
    'privacy.securityTitle': 'Security',
    'privacy.securityBody': 'We protect your data with industry-standard security measures: passwords are hashed with bcrypt, authentication uses secure JWT tokens in httpOnly cookies, all connections are encrypted via TLS, and file uploads are validated and sanitized.',
    'privacy.contactTitle': 'Contact',
    'privacy.contactBody': 'For privacy-related questions or requests, contact us at info@corgimind.com.',

    // --- Refund Policy ---
    'refund.title': 'Refund Policy',
    'refund.lastUpdated': 'Last updated: March 2026',
    'refund.overviewTitle': 'Overview',
    'refund.overviewBody': 'SiliconVault Desktop is a one-time purchase ($50 USD) that grants lifetime access to the application. Pro subscriptions are billed on a recurring basis. The web platform offers a free tier that does not involve any payment. We offer a 14-day refund window for Desktop App purchases — if you are not satisfied, you can request a full refund within 14 days of your purchase date. Pro subscriptions can be cancelled at any time; no refunds are issued for partial billing periods, but you retain access until the end of your current paid period.',
    'refund.eligibilityTitle': 'Eligibility',
    'refund.eligibilityBody': 'For Desktop purchases, you are eligible for a refund if your request is made within 14 days of the original purchase date. Refunds are limited to one per customer. For Pro subscriptions, you may cancel at any time to prevent future charges; no partial-period refunds are issued. We reserve the right to deny refund requests that indicate abuse of this policy (e.g., repeated purchase-and-refund cycles).',
    'refund.howToTitle': 'How to Request a Refund',
    'refund.howToBody': 'To request a refund, send an email to info@corgimind.com with the subject line "Refund Request" and include your purchase email address and order number. We aim to respond to all refund requests within 2 business days.',
    'refund.processingTitle': 'Processing',
    'refund.processingBody': 'Approved refunds are processed through Lemon Squeezy (our payment processor) and returned to your original payment method. Please allow 5–10 business days for the refund to appear on your statement. Upon refund, your license key will be revoked automatically and the desktop app will no longer accept it for activation.',
    'refund.exceptionsTitle': 'Exceptions',
    'refund.exceptionsBody': 'Refunds may be denied in cases of suspected fraud or abuse, including but not limited to: repeated refund requests across multiple accounts, attempts to use the software after requesting a refund, or chargebacks filed simultaneously with a refund request.',
    'refund.contactTitle': 'Contact',
    'refund.contactBody': 'For any questions about refunds or billing, contact us at info@corgimind.com.',

    // --- Stats ---
    'stats.title': 'Collection Stats',
    'stats.noData': 'No data available',
    'stats.emptyTitle': 'No Stats Yet',
    'stats.emptyDesc': 'Add items to your collection to see analytics and charts.',
    'stats.totalItems': 'Total Items',
    'stats.totalValue': 'Total Value',
    'stats.uniquePlatforms': 'Platforms',
    'stats.uniqueCategories': 'Categories',
    'stats.platformDistribution': 'Platform Distribution',
    'stats.conditionBreakdown': 'Condition Breakdown',
    'stats.acquisitionTimeline': 'Acquisition Timeline (12 Months)',
    'stats.valueByCategory': 'Value by Category',

    // --- Activity Feed ---
    'activity.title': 'Activity Feed',
    'activity.emptyTitle': 'No Activity Yet',
    'activity.emptyDesc': 'Community events will appear here as collectors list items, make trades, and join.',
    'activity.filter.all': 'All',
    'activity.filter.item_listed': 'Listings',
    'activity.filter.trade_completed': 'Trades',
    'activity.filter.member_joined': 'New Members',
    'activity.filter.item_showcased': 'Showcased',
    'activity.event.item_listed': 'listed an item',
    'activity.event.trade_completed': 'completed a trade',
    'activity.event.member_joined': 'joined the community',
    'activity.event.item_showcased': 'showcased an item',

    // --- Messaging ---
    'messages.title': 'Messages',
    'messages.emptyTitle': 'No Conversations',
    'messages.emptyDesc': 'Start a conversation by sending a message to another collector from their profile page.',
    'messages.selectConversation': 'Select a conversation',
    'messages.noMessages': 'No messages yet',
    'messages.startConversation': 'Send a message to start the conversation',
    'messages.placeholder': 'Type a message...',
    'messages.sendMessage': 'Send Message',

    // --- Duplicates ---
    'duplicates.title': 'Duplicate Detection',
    'duplicates.scan': 'Scan for Duplicates',
    'duplicates.scanning': 'Scanning...',
    'duplicates.scanPromptTitle': 'Find Duplicate Items',
    'duplicates.scanPromptDesc': 'Click "Scan for Duplicates" to detect items with similar names in your collection.',
    'duplicates.noneFound': 'No Duplicates Found',
    'duplicates.noneFoundDesc': 'Your collection looks clean! No potential duplicates were detected.',
    'duplicates.pairsFound': 'potential duplicates found',
    'duplicates.match': 'match',
    'duplicates.notDuplicate': 'Not a Duplicate',
    'duplicates.keepLeft': 'Keep Left',
    'duplicates.keepRight': 'Keep Right',
    'duplicates.confirmKeep': 'Click again to confirm',

    // --- Sets ---
    'nav.sets': 'Sets',
    'breadcrumb.sets': 'Sets',
    'breadcrumb.setDetail': 'Set Detail',
    'sets.title': 'Collection Sets',
    'sets.createSet': 'New Set',
    'sets.newSet': 'New Set',
    'sets.setName': 'Name',
    'sets.setNamePlaceholder': 'e.g., Complete Commodore Collection',
    'sets.description': 'Description',
    'sets.descriptionPlaceholder': 'Optional description...',
    'sets.fromTemplate': 'From Template',
    'sets.customSet': 'Custom (empty set)',
    'sets.create': 'Create',
    'sets.emptyTitle': 'No Sets Yet',
    'sets.emptyDesc': 'Create a collection set to track which items you own from a target collection.',
    'sets.autoMatch': 'Auto Match',
    'sets.matching': 'Matching...',
    'sets.delete': 'Delete',
    'sets.confirmDelete': 'Confirm Delete',
    'sets.itemsMatched': 'items matched from your inventory',
    'sets.noMatchesFound': 'No matches found',
    'sets.addItemPlaceholder': 'Add item to set...',
    'common.loading': 'Loading...',
    'common.notFound': 'Not found.',
    'common.previous': 'Previous',
    'common.next': 'Next',

    // --- Landing page — Desktop section ---
    'landing.desktopTitle': 'Want Full Control?',
    'landing.desktopSub': 'Take your collection offline. Your data stays on your machine — no cloud, no subscriptions, no compromises.',
    'landing.desktopFeature1Title': 'Fully Offline',
    'landing.desktopFeature1Desc': 'Data stored locally on your device. No internet required after install.',
    'landing.desktopFeature2Title': 'One-Time Purchase',
    'landing.desktopFeature2Desc': '$50 — yours forever with 12 months of updates included. No recurring fees.',
    'landing.desktopFeature3Title': 'Cross-Platform',
    'landing.desktopFeature3Desc': 'Available for macOS, Windows, and Linux.',
    'landing.desktopCta': 'Learn More & Download',

    // --- Download page ---
    'download.heroTitle': 'SiliconVault Desktop',
    'download.heroTagline': 'Offline. Private. Permanent.',
    'download.priceBadge': '$50 — One-time purchase, yours forever',
    'download.platformsTitle': 'Download',
    'download.macTitle': 'macOS',
    'download.macDesc': 'Universal (Apple Silicon + Intel), macOS 11+',
    'download.macButton': 'Download',
    'download.winTitle': 'Windows',
    'download.winDesc': 'Windows 10/11, x64',
    'download.winButton': 'Download',
    'download.linuxTitle': 'Linux',
    'download.linuxDesc': 'x64 — AppImage & .deb available',
    'download.linuxButton': 'Download',
    'download.featuresTitle': 'Why Desktop?',
    'download.feature1Title': 'Fully Offline',
    'download.feature1Desc': 'Your entire collection lives in a local database. No internet connection required after installation.',
    'download.feature2Title': 'Your Data, Your Machine',
    'download.feature2Desc': 'Nothing leaves your computer. No cloud sync, no telemetry, no third-party access.',
    'download.feature3Title': 'AI With Your Own Key',
    'download.feature3Desc': 'Use your own OpenAI or Azure API key for hardware identification. Your key, your costs, your control.',
    'download.feature4Title': 'Export Anytime',
    'download.feature4Desc': 'Export your full collection as CSV, JSON, or a PDF catalog whenever you want. Your data is always portable.',
    'download.feature5Title': 'Local Database',
    'download.feature5Desc': 'Battle-tested embedded database. No server, no setup — just your data in a single file.',
    'download.feature6Title': 'No Telemetry',
    'download.feature6Desc': 'Zero analytics, zero tracking, zero phone-home. The app never contacts any server unless you ask it to.',
    'download.howTitle': 'How It Works',
    'download.step1': 'Download the installer for your platform',
    'download.step2': 'Install and launch SiliconVault Desktop',
    'download.step3': 'Enter your license key',
    'download.step4': 'Start cataloging — fully offline',
    'download.purchaseTitle': 'Get Your License',
    'download.purchaseDesc': 'Purchase a license key to unlock SiliconVault Desktop. Your key will be shown immediately after checkout.',
    'download.licenseCardDesc': 'One-time purchase. No subscription. Your license key is delivered instantly after checkout.',
    'download.purchaseButton': 'Purchase License — $50',
    'download.footer': 'All rights reserved.',

    // --- Download success page ---
    'download.successTitle': 'Purchase Complete!',
    'download.successTagline': 'Your SiliconVault Desktop license is ready.',
    'download.successLicenseLabel': 'Your License Key',
    'download.successCopy': 'Copy to clipboard',
    'download.successCopied': 'Copied!',
    'download.successActivateTitle': 'How to Activate',
    'download.successStep1': 'Download and install SiliconVault Desktop for your platform',
    'download.successStep2': 'Launch the app and enter your email and the license key above',
    'download.successStep3': 'Start cataloging your collection — fully offline',
    'download.successLoading': 'Retrieving your license key...',
    'download.successErrorNoOrder': 'No order ID found. Please check your purchase confirmation.',
    'download.successErrorNotFound': 'License not found. It may take a moment to process — please refresh the page.',
    'download.successErrorGeneric': 'Something went wrong. Please try refreshing the page.',
    'download.successBackToDownload': 'Back to Download',

    // --- About page — Desktop promo ---
    'about.desktopPromoTitle': 'SiliconVault Desktop',
    'about.desktopPromoBody': 'Want offline access? Own your data with the desktop app — fully local, no cloud required.',
    'about.desktopPromoPrice': 'One-time $50',
    'about.desktopPromoCta': 'Learn More',

    // --- Settings — Backup & Restore (desktop) ---
    'settings.backupRestore': 'Backup & Restore',
    'settings.backupDesc': 'Create a snapshot of your entire database. Backups are stored locally alongside the app data.',
    'settings.createBackup': 'Create Backup',
    'settings.creatingBackup': 'Creating...',
    'settings.restoreBackup': 'Restore',
    'settings.restoringBackup': 'Restoring...',
    'settings.deleteBackup': 'Delete',
    'settings.noBackups': 'No backups yet. Create one to protect your data.',
    'settings.backupCreated': 'Backup created successfully.',
    'settings.backupRestored': 'Database restored. Please restart the application.',
    'settings.backupDeleted': 'Backup deleted.',
    'settings.backupFailed': 'Backup failed.',
    'settings.restoreFailed': 'Restore failed.',
    'settings.confirmRestore': 'Are you sure? The current database will be replaced with this backup. A safety snapshot will be created automatically. You will need to restart the app.',
    'settings.confirmDelete': 'Delete this backup? This cannot be undone.',
    'settings.schemaWarning': 'Warning: This backup was created on an older database schema (version {backupVersion}, current is {currentVersion}). After restoring, the app will re-apply newer migrations on next startup. Any data added by those migrations will be reset to defaults.',

    // --- Settings — Desktop promo ---
    'settings.desktopPromoText': 'Looking for offline access? Check out the desktop app',
    'settings.desktopPromoCta': 'Learn more →',

    // --- PDF Export ---
    'pdf.modalTitle': 'Export PDF Catalog',
    'pdf.layoutPrompt': 'Choose a tile layout for your catalog:',
    'pdf.layout_large': 'Large',
    'pdf.layout_compact': 'Compact',
    'pdf.layout_dense': 'Dense',
    'pdf.generate': 'Generate PDF',
    'pdf.generating': 'Generating...',
    'pdf.fetchingImages': 'Fetching images...',
    'pdf.orientation': 'Orientation',
    'pdf.portrait': 'Portrait',
    'pdf.landscape': 'Landscape',

    // --- Share / Public Catalog ---
    'share.title': 'Share Your Catalog',
    'share.shareCatalog': 'Share Catalog',
    'share.copyLink': 'Copy Link',
    'share.copied': 'Copied!',
    'share.facebookCopied': 'Text copied — paste it in your Facebook post',
    'share.shareVia': 'Share via',
    'share.share': 'Share',
    'share.defaultMessage': 'Check out my retro computing catalog on SiliconVault: {url}',
    'share.noSlug': 'You need a profile URL to share your catalog.',
    'share.goToSettings': 'Set one up in Settings',
    'share.backToDashboard': 'Dashboard',
    'share.joinToMessage': 'Join to message',
    'share.ctaHeadline': 'Inspired by this collection? Create your own retro catalog',
    'share.ctaSubtext': 'SiliconVault is free for all retro computing collectors.',
    'share.ctaButton': 'Sign Up Free',
    'share.publicCatalog': 'Public Catalog',
    'share.yourPublicUrl': 'Your public URL',
    'share.viewProfile': 'View Profile',
    'share.noSlugTitle': 'No profile URL set',
    'share.noSlugSettingsDesc': 'Set a profile URL in the Public Profile section above to enable public catalog sharing.',
    'share.setSlugToShare': 'Set a profile URL above to enable sharing.',
    'share.catalogViews': 'Catalog Views',
    'share.totalViews': 'total',
    'share.thisWeek': 'this week',
    'share.thisMonth': 'this month',
    'share.topReferrers': 'Top referrers',
    'share.directVisit': 'Direct',
    'share.ctaSocialProof': 'Join {collectors} collectors sharing {items} items',
    'share.dashboardBannerTitle': 'Share your collection',
    'share.dashboardBannerDesc': 'Let others discover your retro computing catalog',
    'share.dashboardBannerCta': 'Share Now',
    'share.inventoryShareBtn': 'Share',
    'share.sharedVaults': 'Shared Vaults',
    'share.sharedVaultsHint': 'Choose which vaults are visible on your public profile.',
    'share.allVaults': 'All',
    'share.noPublicVaults': 'This collector has no public vaults.',

    // --- Landing page social proof ---
    'landing.socialProof': 'Join {collectors} collectors cataloging {items} items',

    // --- Pricing page ---
    'pricing.heroTitle': 'Simple, Transparent Pricing',
    'pricing.heroTagline': 'Start free. Upgrade when you need more.',
    'pricing.footerLink': 'Pricing',
    'pricing.freeName': 'Free',
    'pricing.freeDesc': 'Everything you need to start cataloging your retro collection.',
    'pricing.freePrice': '$0',
    'pricing.freeSubtext': 'Free forever',
    'pricing.freeFeature1': 'Up to 100 items',
    'pricing.freeFeature2': '1 vault type',
    'pricing.freeFeature3': 'Image uploads',
    'pricing.freeFeature4': 'All 15 themes',
    'pricing.freeFeature5': '5 showroom items',
    'pricing.freeFeature6': 'Sets & collections',
    'pricing.freeFeature7': '5 AI scans/month + unlimited BYOK',
    'pricing.freeFeature8': 'CSV & JSON export',
    'pricing.freeFeature9': 'PDF export',
    'pricing.freeCta': 'Get Started',
    'pricing.proName': 'Pro',
    'pricing.proDesc': 'Unlimited collection management with AI-powered analysis.',
    'pricing.popularBadge': 'Most Popular',
    'pricing.monthly': 'Monthly',
    'pricing.yearly': 'Yearly',
    'pricing.perMonth': '/mo',
    'pricing.perYear': '/yr',
    'pricing.saveBadge': 'Save 33%',
    'pricing.monthlySubtext': 'Billed monthly',
    'pricing.yearlySubtext': '$40 billed annually',
    'pricing.proFeature1': 'Unlimited items',
    'pricing.proFeature2': 'All vault types',
    'pricing.proFeature3': 'CSV, JSON & PDF export',
    'pricing.proFeature4': 'All 15 themes',
    'pricing.proFeature5': 'Unlimited showroom',
    'pricing.proFeature6': '500 AI scans/month + unlimited BYOK',
    'pricing.proFeature7': 'Sets & collections',
    'pricing.proCta': 'Go Pro',
    'pricing.proCtaLoading': 'Loading...',
    'pricing.desktopName': 'Desktop',
    'pricing.desktopDesc': 'Fully offline. Your data stays on your machine.',
    'pricing.desktopSubtext': 'One-time purchase',
    'pricing.desktopFeature1': 'Unlimited local items',
    'pricing.desktopFeature2': 'Image uploads',
    'pricing.desktopFeature3': 'CSV, JSON & PDF export',
    'pricing.desktopFeature4': 'All 15 themes',
    'pricing.desktopFeature5': 'All vault types',
    'pricing.desktopFeature6': 'AI with your own API key',
    'pricing.desktopFeature7': 'Fully offline — no account needed',
    'pricing.desktopFeature8': 'Install on Windows, Mac & Linux',
    'pricing.desktopCta': 'Buy Desktop — $50',

    // --- Upgrade page (in-app) ---
    'upgrade.title': 'Your Plan',
    'upgrade.subtitle': 'Manage your subscription and see what\'s included.',
    'upgrade.currentPlan': 'Current Plan',
    'upgrade.freeBadge': 'Free',
    'upgrade.itemsUsed': 'Items',
    'upgrade.compareTitle': 'Free vs Pro',
    'upgrade.feature': 'Feature',
    'upgrade.freeCol': 'Free',
    'upgrade.proCol': 'Pro',
    'upgrade.featureItems': 'Items',
    'upgrade.freeItems': 'Up to 100',
    'upgrade.proItems': 'Unlimited',
    'upgrade.featureVaults': 'Vaults',
    'upgrade.freeVaults': '1 type',
    'upgrade.proVaults': 'All types',
    'upgrade.featureShowroom': 'Showroom',
    'upgrade.freeShowroom': '5 items',
    'upgrade.proShowroom': 'Unlimited',
    'upgrade.featureAi': 'AI Analysis',
    'upgrade.freeAi': '5/month + own key',
    'upgrade.proAi': '500/month + own key',
    'upgrade.featureExport': 'Export',
    'upgrade.featureThemes': 'All 15 Themes',
    'upgrade.featureSets': 'Sets & Collections',
    'upgrade.featureImages': 'Image Uploads',
    'upgrade.ctaTitle': 'Upgrade to Pro',
    'upgrade.ctaPeriod': 'or $40/year — save 33%',
    'upgrade.ctaPeriodMonthly': 'Billed monthly, cancel anytime',
    'upgrade.ctaPeriodYearly': '$40 billed annually',
    'upgrade.ctaButton': 'Go Pro',
    'upgrade.ctaLoading': 'Redirecting…',
    'upgrade.proActiveTitle': 'You\'re on Pro',
    'upgrade.proActiveDesc': 'Unlimited items, showroom, AI analysis, and PDF export.',
    'upgrade.analysesUsed': 'analyses used',
    'upgrade.remaining': 'remaining',
    'upgrade.resetsOn': 'Resets',
    'upgrade.sidebarBadge': 'Free Plan',
    'upgrade.sidebarBadgePro': 'Pro Plan',
    'upgrade.dashboardBannerTitle': 'Running out of space',
    'upgrade.dashboardBannerDesc': 'You\'ve used {count} of 100 items. Upgrade to Pro for unlimited.',
    'upgrade.dashboardBannerCta': 'Go Pro',
    'upgrade.checkoutError': 'Could not start checkout. Please try again later.',
    'upgrade.successTitle': 'Welcome to Pro!',
    'upgrade.successDesc': 'Your subscription is active. Enjoy unlimited items, showroom, AI analysis, and PDF export.',
    'upgrade.desktopTitle': 'SiliconVault Desktop',
    'upgrade.desktopDesc': 'Fully offline. Your data stays on your machine. Unlimited items, no subscription.',
    'upgrade.desktopPrice': '$50',
    'upgrade.desktopPriceSuffix': 'one-time',
    'batch.skipped': 'Manual',
    'batch.quotaExhausted': 'You\'ve used all your free AI scans this month. The remaining items were added for manual entry. Configure your own API key in Settings for unlimited scans, or upgrade to Pro.',
    'batch.quotaUpgrade': 'Upgrade to Pro',
    'vaults.title': 'Your Vaults',
    'vaults.subtitle': 'Choose a vault to manage, or create a new one to start collecting.',
    'vaults.create': 'Create',
    'vaults.deleteTitle': 'Delete "{name}"?',
    'vaults.deleteWarning': 'This will permanently delete this vault and all inventory items, sets, and wanted items inside it. This action cannot be undone.',
    'vaults.deleteConfirmLabel': 'To confirm, type "{confirmation}" below:',
    'vaults.deleteConfirmText': 'Yes, delete this vault',
    'vaults.deleteBtn': 'Delete Vault',
    'vaults.deleting': 'Deleting...',
    'vaults.cancel': 'Cancel',
    'vaults.switchVault': 'Switch vault',
    'vaults.manageVaults': 'Manage Vaults',
    'vaults.upgradeBadge': 'Upgrade',
    'vaults.upgradeHint': 'Free plan is limited to 1 vault type. Upgrade to Pro to unlock all vault types.',
    'vaults.upgradeCta': 'Go Pro',
    'vaults.type.retro_computers': 'Retro Computers',
    'vaults.type.retro_audio': 'Retro Audio / Hi-Fi',
    'vaults.type.vintage_cameras': 'Vintage Cameras',
    'vaults.type.watches': 'Watches',
    'vaults.tagline.retro_computers': 'Preserve the machines that started it all',
    'vaults.tagline.retro_audio': 'Catalog your vintage sound systems',
    'vaults.tagline.vintage_cameras': 'Document your analog photography collection',
    'vaults.tagline.watches': 'Track your timepiece collection',
    'upgrade.desktopCta': 'Buy Desktop License',
    'upgrade.desktopLoading': 'Redirecting…',
    // Custom vault
    'vaults.customCard.title': 'Custom Vault',
    'vaults.customCard.tagline': 'Create a vault for any collection type',
    'vaults.customCard.taglineShort': 'Custom Collection',
    'vaults.custom.title': 'Create Custom Vault',
    'vaults.custom.subtitle': 'Design a vault for any collection. Define what fields each item should track.',
    'vaults.custom.backToVaults': 'Back to Vaults',
    'vaults.custom.basicInfo': 'Basic Info',
    'vaults.custom.vaultName': 'Vault Name',
    'vaults.custom.vaultNamePlaceholder': 'e.g. Vinyl Records, Sneakers, Trading Cards',
    'vaults.custom.description': 'Description',
    'vaults.custom.descriptionPlaceholder': 'Describe what this collection is about. This helps AI analyze your items more accurately.',
    'vaults.custom.platformLabel': 'Platform / Brand Label',
    'vaults.custom.platformLabelPlaceholder': 'e.g. Brand, Publisher, Label',
    'vaults.custom.icon': 'Icon',
    'vaults.custom.createVault': 'Create Vault',
    'vaults.custom.upgradeToCreate': 'Upgrade to Create Custom Vaults',
    'vaults.custom.createFailed': 'Failed to create vault',
    // Vault settings
    'vaults.settings.title': 'Vault Settings',
    'vaults.settings.subtitle': 'Edit your custom vault\'s fields and metadata. Changes apply to new items — existing item data is preserved.',
    'vaults.settings.backToDashboard': 'Back to Dashboard',
    'vaults.settings.vaultInfo': 'Vault Info',
    'vaults.settings.saveChanges': 'Save Changes',
    'vaults.settings.saved': 'Settings saved successfully.',
    'vaults.settings.saveFailed': 'Failed to save',
    'vaults.settings.notCustom': 'Vault settings are only available for custom vaults.',
    'vaults.settings.navLabel': 'Vault Settings',
    // Field editor
    'fieldEditor.includedByDefault': 'Included by Default',
    'fieldEditor.builtinToggle': 'Every item automatically includes these fields — you don\'t need to add them',
    'fieldEditor.groupCore': 'Core',
    'fieldEditor.groupStatus': 'Status',
    'fieldEditor.groupFinancial': 'Financial',
    'fieldEditor.groupNotes': 'Notes',
    'fieldEditor.required': 'required',
    'fieldEditor.fieldName': 'Name',
    'fieldEditor.fieldCategory': 'Category',
    'fieldEditor.fieldSubcategory': 'Subcategory',
    'fieldEditor.fieldCondition': 'Condition',
    'fieldEditor.fieldLocation': 'Location',
    'fieldEditor.fieldAcquisition': 'Acquisition Date & Price',
    'fieldEditor.fieldLaunch': 'Launch Date & Price',
    'fieldEditor.fieldDescription': 'Description',
    'fieldEditor.fieldCustomNotes': 'Custom Notes',
    'fieldEditor.additionalFields': 'Additional Fields',
    'fieldEditor.additionalFieldsDesc': 'Add extra fields specific to your collection. These appear alongside the built-in fields above.',
    'fieldEditor.selectedFields': 'Selected Fields ({count}/20)',
    'fieldEditor.emptyFields': 'No fields added yet. Pick from the library above or create a custom field.',
    'fieldEditor.removeField': 'Remove field',
    'fieldEditor.addCustomField': 'Add Custom Field',
    'fieldEditor.fieldLabel': 'Field Label',
    'fieldEditor.fieldLabelPlaceholder': 'e.g. Frame Material',
    'fieldEditor.fieldType': 'Type',
    'fieldEditor.fieldKey': 'Key (auto-generated)',
    'fieldEditor.fieldKeyPlaceholder': 'field_key',
    'fieldEditor.placeholderLabel': 'Placeholder (optional)',
    'fieldEditor.placeholderPlaceholder': 'e.g. Enter value...',
    'fieldEditor.optionsLabel': 'Options (min 2)',
    'fieldEditor.optionsPlaceholder': 'Type option and press Enter',
    'fieldEditor.addField': 'Add Field',
    'fieldEditor.type.text': 'Text',
    'fieldEditor.type.number': 'Number',
    'fieldEditor.type.select': 'Dropdown',
    'fieldEditor.type.date': 'Date',
    'fieldEditor.type.boolean': 'Yes / No',
    'fieldEditor.type.url': 'URL',
    'fieldEditor.warn.platform': 'The "{label}" field already captures this. Consider adjusting your "{label}" label instead.',
    'fieldEditor.warn.description': 'A "Description" field is already included by default.',
    'fieldEditor.warn.notes': 'A "Custom Notes" field is already included by default.',
    'fieldEditor.warn.name': 'A "Name" field is already included by default.',
    'fieldEditor.warn.category': 'A "Category" field is already included by default.',
    'fieldEditor.warn.condition': 'A "Condition" dropdown is already included by default.',
    'fieldEditor.warn.price': 'Acquisition Price and Launch Price fields are already included by default.',
    'fieldEditor.warn.location': 'A "Location" field is already included by default.',
    // Predefined field groups
    'fieldEditor.group.General': 'General',
    'fieldEditor.group.Electronics & Computing': 'Electronics & Computing',
    'fieldEditor.group.Optics & Photography': 'Optics & Photography',
    'fieldEditor.group.Horology': 'Horology',
    'fieldEditor.group.Collectibles & Trading': 'Collectibles & Trading',
    // Predefined field labels
    'fieldEditor.predef.serial_number': 'Serial Number',
    'fieldEditor.predef.year': 'Year',
    'fieldEditor.predef.color': 'Color',
    'fieldEditor.predef.material': 'Material',
    'fieldEditor.predef.weight': 'Weight',
    'fieldEditor.predef.dimensions': 'Dimensions',
    'fieldEditor.predef.edition': 'Edition',
    'fieldEditor.predef.country_of_origin': 'Country of Origin',
    'fieldEditor.predef.manufacturer': 'Manufacturer',
    'fieldEditor.predef.rarity': 'Rarity',
    'fieldEditor.predef.certification': 'Certification / Grading',
    'fieldEditor.predef.is_complete': 'Complete Set',
    'fieldEditor.predef.reference_url': 'Reference URL',
    'fieldEditor.predef.cpu': 'CPU / Processor',
    'fieldEditor.predef.memory': 'Memory / RAM',
    'fieldEditor.predef.storage_capacity': 'Storage Capacity',
    'fieldEditor.predef.wattage': 'Wattage',
    'fieldEditor.predef.connectivity': 'Connectivity',
    'fieldEditor.predef.lens_mount': 'Lens Mount',
    'fieldEditor.predef.focal_length': 'Focal Length',
    'fieldEditor.predef.aperture_range': 'Aperture Range',
    'fieldEditor.predef.film_format': 'Film Format',
    'fieldEditor.predef.movement_type': 'Movement Type',
    'fieldEditor.predef.case_material': 'Case Material',
    'fieldEditor.predef.case_diameter': 'Case Diameter',
    'fieldEditor.predef.water_resistance': 'Water Resistance',
    'fieldEditor.predef.crystal_type': 'Crystal Type',
    'fieldEditor.predef.mint_mark': 'Mint Mark',
    'fieldEditor.predef.face_value': 'Face Value',
    'fieldEditor.predef.denomination': 'Denomination',
    'fieldEditor.predef.artist': 'Artist / Designer',
    'fieldEditor.predef.issue_number': 'Issue Number',
    'fieldEditor.predef.print_run': 'Print Run',
    // Default platform label
    'fieldEditor.defaultPlatformLabel': 'Brand',
    'settings.themeVivid': 'Vivid',

    // --- Feedback ---
    'nav.feedback': 'Feedback',
    'feedback.title': 'Feedback & Support',
    'feedback.subtitle': 'Report bugs, request features, or share your thoughts.',
    'feedback.typeBug': 'Bug Report',
    'feedback.typeFeature': 'Feature Request',
    'feedback.typeFeedback': 'General Feedback',
    'feedback.typeQuestion': 'Question',
    'feedback.titleLabel': 'Title',
    'feedback.titlePlaceholder': 'Brief summary of your feedback',
    'feedback.descriptionLabel': 'Description',
    'feedback.descriptionPlaceholder': 'Tell us more...',
    'feedback.submit': 'Submit Feedback',
    'feedback.myTickets': 'My Tickets',
    'feedback.noTickets': 'No tickets yet',
    'feedback.noTicketsDesc': 'Your submitted feedback will appear here.',
    'feedback.submitted': 'Feedback submitted successfully!',
    'feedback.statusOpen': 'Open',
    'feedback.statusInProgress': 'In Progress',
    'feedback.statusResolved': 'Resolved',
    'feedback.statusClosed': 'Closed',
    'feedback.adminReply': 'Admin Reply',
    'feedback.noReply': 'No reply yet',

    // --- Admin Feedback ---
    'admin.feedbackTab': 'Feedback',
    'admin.feedback.title': 'User Feedback',
    'admin.feedback.reply': 'Reply',
    'admin.feedback.replyPlaceholder': 'Write a reply...',
    'admin.feedback.sendReply': 'Send Reply',
    'admin.feedback.changeStatus': 'Change Status',
    'admin.feedback.noTickets': 'No feedback tickets',
} as const;

export type TranslationKey = keyof typeof en;
export type Translations = Record<TranslationKey, string>;
export default en;
